<template>
  <div class="containerPresciption">
    <div class="headerInventory">
      <p style="margin: 0px !important; font-size: 1rem; font-weight: bold">
        {{ getComponenteTitle }}
      </p>
    </div>

    <div
      v-if="inspectionOrigin && pendingInspectionProducts.length"
      class="inspectionImportNotice"
    >
      <strong>Produtos preparados pela inspeção</strong>
      <div class="inspectionImportProducts">
        <div
          v-for="(product, index) in pendingInspectionProducts"
          :key="product.inspectionRecommendationId || `${product.idProduto}-${index}`"
          class="inspectionImportProduct"
        >
          <span>{{ product.nome }}</span>
          <label>
            Quantidade
            <input v-model.number="product.quantidade" type="number" min="0.001" step="any" />
          </label>
          <label>
            Área
            <input
              v-model.number="product.infortecnicaReceita.areatratar"
              type="number"
              min="0.001"
              step="any"
            />
          </label>
          <label>
            Aplicações
            <input
              v-model.number="product.infortecnicaReceita.numAplicacoes"
              type="number"
              min="1"
              step="1"
            />
          </label>
          <button
            type="button"
            :aria-label="`Excluir ${product.nome} da receita`"
            :disabled="isImportingInspectionProducts"
            @click="removePendingInspectionProduct(product)"
          >
            Excluir
          </button>
        </div>
      </div>
      <small v-if="hasInvalidInspectionProducts">
        Revise a quantidade, a área e o número de aplicações de todos os produtos.
      </small>
      <small v-else-if="missingInspectionPrescriptionFields.length">
        Falta preencher:
        {{ missingInspectionPrescriptionFields.join(", ") }}.
      </small>
      <small v-else>
        Os dados obrigatórios estão preenchidos. Revise e gere a receita para
        incluir os produtos automaticamente.
      </small>
    </div>

    <div style="margin-bottom: 100px" v-if="typeComponent === 'Pedido'">
      <section id="dadosGerais">
        <div class="formFront">
          <div class="descriptionSection">
            <b-icon-receipt /> <span> Dados Gerais</span>
          </div>

          <div
            class="rowContent"
            style="border-bottom: 1px solid #c8dfd5; padding-bottom: 10px"
          >
            <Input
              ref="data"
              label="Data"
              type="date"
              :dataInput.sync="sale.data"
              :labelFixed="true"
              style="height: 30px; width: 45%"
            />

            <InputInfinit
              label="Cliente"
              typeFilter="customer"
              :isEdit="sale.idCliente"
              :dataInput.sync="sale.idCliente"
              :onSearch="fillCustomerComboBoxWithPaginate"
              :openCreateModal="() => openModals('modalCreateCustomerMobile')"
              :findAll="createdNewCustomer"
              :clearSelected="newOrder"
              @selectItem="handleDataCustomers"
            />
            <InputSelect
              label="Funcionário"
              :items="dataEmployees"
              valueField="id"
              textField="nomeFuncionario"
              :dataSelect.sync="sale.idFuncionario"
              :openCreateModal="() => openModals('modalCreateEmployeeMobile')"
              ref="funcionario"
              style="height: 30px"
            />
          </div>
        </div>
      </section>

      <div class="carroselCtn">
        <div class="StatementOnAccount">
          <label
            v-for="item in tabs"
            :key="item.text"
            class="StatementOnAccountItem"
            :class="{ active: selectedTabLabel === item.value }"
            @click="storeLabelTabName(item.value)"
          >
            {{ item.text }} <br />
          </label>
        </div>
      </div>

      <div
        v-show="selectedTabLabel === 'additional_information'"
        style="margin-bottom: 100px"
      >
        <AdditionalInformation
          :sale="sale"
          :totalValue="objectTotals.totalOfSale"
          :toggleToClearBills="newOrder"
          :allPaymentsTypes="allPaymentsTypes"
          :totals="objectTotals"
          @findProducts="handleFindProducts"
          ref="additionalInformationRef"
          @listPaymentMethods="getAllPayment"
        />
      </div>

      <div v-show="selectedTabLabel === 'order'" style="margin-bottom: 100px">
        <SimpleProductsMobile
          :sale="sale"
          :outsideTableProducts="tableProducts"
          :totals="objectTotals.byType.simples"
          :listNcms="listNcms"
          :allRefsFiscais="allRefsFiscais"
          @findTableProductsOfSale="handleFindProductsAndCalculateTotals"
          @calculateTotalValues="handleCalculateObjectTotal"
          @updateSale="handleUpdateSale"
          @openModalRef="handleOpenModalRef"
        />
      </div>
    </div>

    <div class="MobileStepperContainer" v-if="selectedTabLabel !== 'order'">
      <div class="stepper-header">
        <button
          class="step-nav-btn"
          :disabled="currentStep === 0"
          aria-label="Step anterior"
          @click="goPrevStep"
        >
          <b-icon-chevron-left scale="1.1"></b-icon-chevron-left>
        </button>

        <div class="stepper-center">
          <div class="stepper-pills">
            <div
              v-for="(step, index) in steps"
              :key="index"
              class="step-pill"
              :class="{
                active: currentStep === index,
                completed: currentStep > index,
              }"
            >
              <span class="step-pill-index">
                <b-icon-check
                  v-if="currentStep > index"
                  scale="0.9"
                ></b-icon-check>
                <span v-else>{{ index + 1 }}</span>
              </span>
              <span class="step-pill-label">{{ step.label }}</span>
            </div>
          </div>

          <div class="stepper-progress-track">
            <div
              class="stepper-progress-fill"
              :style="{ width: stepProgressWidth }"
            ></div>
          </div>
        </div>

        <button
          class="step-nav-btn"
          :disabled="currentStep === steps.length - 1"
          aria-label="Próximo step"
          @click="goNextStep"
        >
          <b-icon-chevron-right scale="1.1"></b-icon-chevron-right>
        </button>
      </div>

      <div class="stepper-content-wrapper">
        <div class="step-panels-wrapper">
          <div v-show="currentStep === 0" class="step-panel" key="step1">
            <section id="dadosGerais">
              <div class="formFront">
                <div class="descriptionSection">
                  <b-icon-receipt /> <span> Dados Gerais</span>
                </div>
                <div
                  class="rowContent"
                  style="border-bottom: 1px solid #c8dfd5; padding-bottom: 10px"
                >
                  <div style="display: flex; justify-content: space-between">
                    <Input
                      ref="data"
                      label="Data"
                      type="date"
                      :dataInput.sync="sale.data"
                      :labelFixed="true"
                      style="height: 30px; width: 45%"
                    />
                    <InputSelect
                      label="Situação da Receita"
                      :items="prescriptionStatusOptions"
                      valueField="value"
                      textField="text"
                      :enableIconCreate="false"
                      :dataSelect.sync="sale.situacaoReceita"
                      :dataInput="sale.situacaoReceita"
                      style="height: 30px; width: 45%"
                      ref="situacaoReceita"
                    />
                  </div>
                  <InputInfinit
                    label="Cliente"
                    typeFilter="customer"
                    :isEdit="sale.idCliente"
                    :dataInput.sync="sale.idCliente"
                    :onSearch="fillCustomerComboBoxWithPaginate"
                    :openCreateModal="
                      () => openModals('modalCreateCustomerMobile')
                    "
                    :findAll="createdNewCustomer"
                    :clearSelected="newOrder"
                    @selectItem="handleDataCustomers"
                  />
                  <InputSelect
                    label="Funcionário"
                    :items="dataEmployees"
                    valueField="id"
                    textField="nomeFuncionario"
                    :dataSelect.sync="sale.idFuncionario"
                    :openCreateModal="
                      () => openModals('modalCreateEmployeeMobile')
                    "
                    ref="funcionario"
                    style="height: 30px"
                  />
                </div>
                <div class="rowContent" style="padding-top: 5px">
                  <InputSelect
                    label="Propriedade"
                    :items="dataProperties"
                    valueField="id"
                    textField="nome"
                    :enableIconCreate="false"
                    :dataSelect.sync="sale.idPropriedade"
                    :openCreateModal="() => openModals('modalCreateProperty')"
                    ref="idPropriedade"
                    style="height: 30px"
                    @selectedCompletedItem="handleAssingUfProperty"
                  />

                  <div>
                    <InputSelect
                      label="Responsável Técnico"
                      valueField="id"
                      textField="nome"
                      :items="dataTechnicalManagers"
                      :dataSelect.sync="sale.idResponsavelTecnico"
                      :openCreateModal="
                        () => openModals('modalCreateTechnicalManager')
                      "
                      :isDisabled="
                        reusePrescription || sale.status === 'Cancelado'
                      "
                      :tabindex="
                        reusePrescription || sale.status === 'Cancelado'
                          ? -1
                          : ''
                      "
                      ref="idResponsavelTecnico"
                      style="height: 30px; width: 100%"
                      @selectedIten="handleDataTech($event)"
                    />

                    <span
                      style="color: #7a9c87; font-size: 9px; padding-left: 2px"
                      >{{
                        remainingPrescriptions
                          ? `Receitas restantes: ${remainingPrescriptions}`
                          : ""
                      }}</span
                    >
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <Input
                      label="N° ART/ TRT"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="sale.art"
                      tabindex="-1"
                      ref="art"
                      style="height: 30px; width: 32%"
                      isDisabled
                    />
                    <Input
                      label="N° Receita"
                      :labelFixed="true"
                      type="number"
                      :dataInput.sync="sale.receita"
                      ref="receita"
                      style="height: 30px; width: 32%"
                    />
                    <Input
                      label="Complemento"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="sale.complementoReceita"
                      tabindex="-1"
                      ref="complementoReceita"
                      style="height: 30px; width: 32%"
                      isDisabled
                    />
                    <Input
                      v-if="getCompanyUf === 'SC'"
                      label="Série SC"
                      :labelFixed="true"
                      type="number"
                      :dataInput.sync="sale.serieSC"
                      tabindex="-1"
                      ref="serieSC"
                      style="height: 30px; width: 32%"
                      isDisabled
                    />
                  </div>
                </div>
                <div class="rowContent">
                  <div style="display: flex; justify-content: space-between">
                    <Input
                      label="Data NF-e"
                      type="date"
                      :dataInput.sync="sale.dataNfe"
                      :labelFixed="true"
                      style="height: 30px; width: 30%"
                      ref="dataNfe"
                    />
                    <Input
                      label="N° NF-e"
                      :labelFixed="true"
                      type="number"
                      :dataInput.sync="sale.numeroNFe"
                      ref="numeroNFe"
                      style="height: 30px; width: 30%"
                    />
                    <Input
                      label="Série"
                      :labelFixed="true"
                      type="number"
                      :dataInput.sync="sale.serieNFe"
                      style="height: 30px; width: 30%"
                      ref="serieNFe"
                    />
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <InputMoney
                      label="Valor"
                      labelFixed
                      ref="valor"
                      type="text"
                      :dataInput.sync="sale.valor"
                      style="height: 30px; width: 20%"
                    />
                    <Input
                      label="Chave Nf-e"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="sale.chaveNFe"
                      maxlength="44"
                      style="height: 30px; width: 75%"
                      ref="chaveNFe"
                    />
                  </div>
                  <InputSelect
                    label="Aplicador"
                    :items="dataApplicators"
                    valueField="id"
                    textField="nomeAplicador"
                    :dataSelect.sync="sale.idAplicador"
                    :dataInput="sale.idAplicador"
                    :openCreateModal="() => openModals('modalCreateApplicatorMobile')"
                    ref="aplicador"
                    style="height: 30px; width: 100%; margin-top: 10px"
                  />
                </div>
                <div class="rowContent">
                  <div class="rowContentMensagem">
                    <div class="selectPlus1">
                      <InputSelect
                        label="Cadastro de Mensagem"
                        :items="messages.geral"
                        valueField="id"
                        textField="titulo"
                        :dataSelect.sync="dataPrescription.observacao"
                        :dataInput="dataPrescription.observacao"
                        :openCreateModal="
                          () => handleOpenModalsMessage('geral')
                        "
                        @selectedCompletedItem="
                          handleAssingMessage($event, 'observacao')
                        "
                      />
                    </div>
                    <textarea
                      class="inputTextArea"
                      rows="3"
                      max-rows="6"
                      v-model="sale.observacoesReceita"
                    />
                  </div>

                  <div class="rowContentMensagem">
                    <div class="selectPlus1">
                      <InputSelect
                        label="MIP (Manejo Integrado de Pragas)"
                        :items="messages.mip"
                        valueField="id"
                        textField="titulo"
                        :dataSelect.sync="dataPrescription.obsmip"
                        :dataInput="dataPrescription.obsmip"
                        :openCreateModal="() => handleOpenModalsMessage('mip')"
                        @selectedCompletedItem="
                          handleAssingMessage($event, 'mip')
                        "
                      />
                    </div>
                    <textarea
                      class="inputTextArea"
                      rows="3"
                      max-rows="6"
                      v-model="sale.mip"
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div v-show="currentStep === 1" class="step-panel" key="step2">
            <section id="dadosProdutos" class="sectionAgro">
              <div class="formFront">
                <div
                  class="descriptionSection pb-2"
                  style="justify-content: space-between"
                >
                  <div style="display: flex; gap: 10px; align-items: center">
                    <b-icon-droplet-fill />
                    <span> Dados produto, cultura e diagnóstico </span>
                  </div>

                  <b-button
                    class="btnResetCultureDiag"
                    @click="handleResetCultureDiag"
                    v-if="currentProduct.infortecnicaReceita.idCultura"
                  >
                    <p style="font-weight: bold">X</p>
                    <p>Limpar cultura e diagnóstico</p>
                  </b-button>
                </div>
                <div class="rowContent">
                  <InputProducts
                    label="1. Selecione o Agrotóxico (Produto)"
                    typeFilter="itens"
                    :isEdit="currentProduct.infortecnicaReceita.idAgrotoxico"
                    :dataInput.sync="
                      currentProduct.infortecnicaReceita.idAgrotoxico
                    "
                    :onSearch="fillPesticidesComboBoxWithPaginate"
                    :enableIconCreate="false"
                    :clearSelected="toggleClearSelect"
                    :searchFields="['nomeComum']"
                    @selectItem="handlePesticideSelection($event)"
                    @closed="handleOpenModalPesticideAlert"
                  />
                  <InputSelect
                    label="2. Selecione a Cultura"
                    :items="dataCultures"
                    valueField="idCultura"
                    textField="nome"
                    :enableIconCreate="false"
                    :dataSelect.sync="
                      currentProduct.infortecnicaReceita.idCultura
                    "
                    :isDisabled="
                      dataCultures.length === 0 || handleDisabledCultureDiags
                    "
                    @selectedCompletedItem="handleCultureSelection($event)"
                    ref="idCultura"
                  />
                  <InputSelect
                    label="3. Selecione o Diagnóstico (Alvo)"
                    :items="dataTargets"
                    valueField="idIndicacao"
                    textField="masterName"
                    :enableIconCreate="false"
                    :dataSelect.sync="
                      currentProduct.infortecnicaReceita.idIndicacao
                    "
                    :isDisabled="
                      dataTargets.length === 0 || handleDisabledCultureDiags
                    "
                    @selectedCompletedItem="handleDiagnosisSelection($event)"
                    ref="idIndicacao"
                  />
                </div>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 10px;
                    align-items: center;
                  "
                >
                  <span style="color: #7a9c87; font-size: 11px"
                    >Utilizar Dose / Volume de calda</span
                  >
                  <div class="radio-input">
                    <label>
                      <input
                        value="minimo"
                        name="dose-radio"
                        type="radio"
                        v-model="
                          currentProduct.infortecnicaReceita.doseSelectionMode
                        "
                        @change="onDoseModeChange"
                      />
                      <span>Mínimo</span>
                    </label>
                    <label>
                      <input
                        value="maximo"
                        name="dose-radio"
                        type="radio"
                        v-model="
                          currentProduct.infortecnicaReceita.doseSelectionMode
                        "
                        @change="onDoseModeChange"
                      />
                      <span>Máximo</span>
                    </label>
                    <label>
                      <input
                        value="intervalo"
                        name="dose-radio"
                        type="radio"
                        v-model="
                          currentProduct.infortecnicaReceita.doseSelectionMode
                        "
                        @change="onDoseModeChange"
                      />
                      <span>Intervalo</span>
                    </label>
                    <span class="selection"></span>
                  </div>
                </div>
                <div
                  class="rowContent"
                  style="align-items: center; padding: 5px 0 0px 0"
                >
                  <div style="display: flex; justify-content: space-between">
                    <div
                      style="display: flex; flex-direction: column; width: 45%"
                    >
                      <Input
                        label="Int. de aplicação (dias)"
                        :labelFixed="true"
                        style="width: 100%"
                        :dataInput.sync="
                          currentProduct.infortecnicaReceita.intervaloAplicacao
                        "
                        ref="intervaloAplicacao"
                      />
                      <span
                        style="
                          color: #7a9c87;
                          font-size: 9px;
                          padding-left: 2px;
                        "
                        >Int. de seg. (dias) :
                        {{
                          this.currentProduct.infortecnicaReceita
                            .intervaloSeguranca
                        }}</span
                      >
                    </div>
                    <div
                      style="display: flex; flex-direction: column; width: 45%"
                    >
                      <Input
                        type="text"
                        label="N° de Aplicações"
                        :labelFixed="true"
                        style="width: 100%"
                        :dataInput.sync="
                          currentProduct.infortecnicaReceita.numAplicacoes
                        "
                        ref="numAplicacoes"
                      />
                      <span
                        style="
                          color: #7a9c87;
                          font-size: 9px;
                          padding-left: 2px;
                        "
                        >N° MÁX de aplicações - Bula:
                        {{
                          this.currentProduct.infortecnicaReceita
                            .maxAplicacoesBula
                        }}</span
                      >
                    </div>
                  </div>
                  <div
                    style="display: flex; flex-direction: column; width: 100%"
                  >
                    <Input
                      label="Estágio de cultura"
                      style="width: 100%"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="
                        currentProduct.infortecnicaReceita.estagioCultura
                      "
                      :list="`estagios-cultura-${_uid}`"
                      ref="estagioCultura"
                    />
                    <datalist :id="`estagios-cultura-${_uid}`">
                      <option v-for="stage in cultureStages" :key="stage" :value="stage" />
                    </datalist>
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div
                      style="display: flex; flex-direction: column; width: 45%"
                    >
                      <Input
                        style="width: 100%"
                        label="Dose utilizada"
                        :labelFixed="true"
                        :dataInput.sync="
                          currentProduct.infortecnicaReceita.doseUtilizada
                        "
                        ref="doseUtilizada"
                      />
                      <span
                        style="
                          color: #7a9c87;
                          font-size: 9px;
                          padding-left: 2px;
                        "
                        >Dose/Bula :
                        {{ this.currentProduct.infortecnicaReceita.doseBula }} -
                        {{
                          this.currentProduct.infortecnicaReceita.unidadeDose
                        }}</span
                      >
                    </div>
                    <div
                      style="display: flex; flex-direction: column; width: 45%"
                    >
                      <Input
                        label="Vol. de calda utilizado"
                        style="width: 100%"
                        :labelFixed="true"
                        :dataInput.sync="
                          currentProduct.infortecnicaReceita
                            .volumeCaldaUtilizado
                        "
                        ref="volumeCaldaUtilizado"
                      />
                      <span
                        style="
                          color: #7a9c87;
                          font-size: 9px;
                          padding-left: 2px;
                        "
                        >Vol. Calda/Bula:
                        {{
                          this.currentProduct.infortecnicaReceita
                            .volumeCaldaBula
                        }}
                        -
                        {{
                          this.currentProduct.infortecnicaReceita
                            .unidadeVolumeCalda
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="rowContent" style="padding-top: 15px">
                  <div class="rowContentMensagem">
                    <div class="selectPlus1">
                      <label
                        class="fixedSelect3"
                        style="font-size: 11px; top: -10px"
                        >Forma de aplicação (Observações sobre a
                        aplicação)</label
                      >
                      <textarea
                        class="inputTextArea"
                        rows="4"
                        max-rows="6"
                        v-model="
                          currentProduct.infortecnicaReceita.formaAplicacao
                        "
                      />
                    </div>
                  </div>
                  <div class="rowContentMensagem">
                    <div class="selectPlus1">
                      <label
                        class="fixedSelect3"
                        style="font-size: 11px; top: -10px"
                        >Época de aplicação e observações adicionais</label
                      >
                      <textarea
                        class="inputTextArea"
                        rows="4"
                        max-rows="6"
                        v-model="
                          currentProduct.infortecnicaReceita.epocaAplicacao
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div v-show="currentStep === 2" class="step-panel" key="step3">
            <section
              id="dadosTecnicos"
              class="sectionAgro"
              style="margin-bottom: 50px"
            >
              <div class="formFront">
                <div class="descriptionSection">
                  <b-icon-exclamation-triangle-fill />
                  <span> Dados Técnicos </span>
                </div>
                <div class="rowContent">
                  <div style="display: flex; justify-content: space-between">
                    <Input
                      style="width: 20%"
                      label="Área"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="
                        currentProduct.infortecnicaReceita.areatratar
                      "
                      ref="areatratar"
                    />
                    <div class="selectPlus1" style="width: 20%">
                      <label class="fixedSelect2">Medida</label>
                      <b-form-select
                        class="borderInput shadow-none"
                        value-field="value"
                        text-field="text"
                        :options="medida"
                        v-model="currentProduct.infortecnicaReceita.medida"
                      >
                      </b-form-select>
                    </div>
                    <b-button class="form-btn-calculator" @click="calcArea">
                      <b-icon-calculator></b-icon-calculator
                    ></b-button>

                    <Input
                      style="width: 20%"
                      label="Qt. Emb"
                      :labelFixed="true"
                      type="number"
                      :dataInput.sync="currentProduct.quantidade"
                      @calculateTotal="handleCalculateTotal"
                      ref="quantidade"
                      isSelectAll
                    />
                    <b-button
                      class="form-btn-calculator"
                      @click="calcQuantProd"
                    >
                      <b-icon-calculator></b-icon-calculator
                    ></b-button>
                  </div>

                  <div class="stock-field">
                    <InputSelectStock
                      style="width: 100%"
                      label="Embalagens"
                      valueField="descricao"
                      textField="descricao"
                      :items="listEmbs"
                      :dataSelect.sync="
                        currentProduct.infortecnicaReceita.embalagem
                      "
                      :enableIconCreate="false"
                      @selectedIten="handleAssingEmb"
                      ref="embalagem"
                    />
                    <span
                      v-if="
                        sale.tipo === 'Receita Pedido' &&
                        currentProductStock !== null
                      "
                      :class="[
                        'current-stock',
                        { 'current-stock-negative': currentProductStock < 0 },
                      ]"
                    >
                      Estoque Atual: {{ currentProductStock }}
                    </span>
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="selectPlus1" style="width: 60%">
                      <label class="fixedSelect2">Lote</label>

                      <b-form-input
                        class="borderInput shadow-none"
                        v-model="currentProduct.infortecnicaReceita.lote"
                        list="lista-de-lotes"
                        autocomplete="off"
                        @blur="handleAssingVlUnit"
                      ></b-form-input>

                      <b-form-datalist
                        id="lista-de-lotes"
                        text-field="lote"
                        value-field="lote"
                        :options="dataLotes"
                      ></b-form-datalist>
                    </div>
                    <ApplicationPeriodInput
                      :dataInput.sync="
                        currentProduct.infortecnicaReceita.horario
                      "
                      ref="horario"
                    />
                  </div>
                </div>

                <div class="rowContent">
                  <div class="selectPlus1">
                    <InputSelect
                      style="width: 100%"
                      label="Modalidade de aplicação"
                      valueField="id"
                      textField="nome"
                      :items="dataAplications"
                      :enableIconCreate="false"
                      :dataSelect.sync="
                        currentProduct.infortecnicaReceita.idTipoAplicacao
                      "
                      @selectedCompletedItem="handleChangeAplication"
                      ref="idTipoAplicacao"
                    />
                  </div>

                  <div
                    v-if="sale.tipo === 'Receita Pedido'"
                    :class="[
                      'item-tax-ref-field-mobile',
                      {
                        'item-tax-ref-field-ref':
                          !currentProduct.usar_imposto_manual,
                      },
                    ]"
                  >
                    <ItemManualTax
                      :item="currentProduct"
                      modal-id="agro-mobile-item-manual-tax"
                    />

                    <InputSearchSelect
                      key="classe_imposto"
                      style="width: 100%"
                      label="REF Fiscal"
                      valueField="ref"
                      textField="descricao"
                      :items="allRefsFiscais"
                      :dataSelect.sync="currentProduct.classe_imposto"
                      labelFixed="true"
                      :openCreateModal="handleOpenModalRef"
                      @changed="assignCurrentItemTaxFromRef"
                      ref="classe_imposto"
                    />
                  </div>

                  <InputSearchSelect
                    v-if="sale.tipo === 'Receita Pedido'"
                    key="ncm"
                    style="width: 70%"
                    label="Lista de NCM"
                    valueField="codigo_ncm"
                    textField="nomeNcm"
                    :items="listNcms"
                    :dataSelect.sync="currentProduct.ncm"
                    labelFixed="true"
                    :openCreateModal="() => openModals('modalNcms')"
                    ref="ncm"
                  />

                  <InputMoney
                    v-if="typeComponent !== 'Receita'"
                    label="Vl. Unit"
                    labelFixed
                    ref="valorUnitario"
                    type="text"
                    :dataInput.sync="currentProduct.valorUnitario"
                    @calculateTotal="handleCalculateTotal"
                    isSelectAll
                  />

                  <InputMoney
                    v-if="typeComponent !== 'Receita'"
                    label="Vl. Total"
                    labelFixed
                    ref="valorTotal"
                    type="text"
                    isDisabled
                    :dataInput.sync="currentProduct.valorTotal"
                    @calculateTotal="handleCalculateTotal"
                  />

                  <div
                    v-if="typeComponent !== 'Receita'"
                    style="
                      width: 30%;
                      display: flex;
                      justify-content: space-between;
                      position: relative;
                    "
                  >
                    <InputMoney
                      style="width: 100%"
                      v-if="!discountIsChecked"
                      label="Desc"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="currentProduct.desconto"
                      ref="discountItem"
                      @calculateTotal="handleCalculateTotal"
                      isSelectAll
                    />

                    <InputPercentage
                      v-else
                      style="width: 100%"
                      label="Desc"
                      :labelFixed="true"
                      type="text"
                      :dataInput.sync="currentProduct.desconto"
                      ref="discountItem"
                      @calculateTotal="handleCalculateTotal"
                      isSelectAll
                    />
                  </div>

                  <div
                    class="itemToggleDesc"
                    style="width: 150px; height: 30px"
                    v-if="typeComponent !== 'Receita'"
                  >
                    <label class="switch col-sm-2 col-md-2 col-lg-2 col-xl-2">
                      <input
                        type="checkbox"
                        ref="typeDiscount"
                        @click="alterDiscountIsChecked"
                        :value="discountIsChecked"
                        :disabled="validatorDesc"
                      />

                      <div class="slider">
                        <span>R$</span>
                        <span>%</span>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="rowContentMensagem" style="padding: 10px 0 5px 0">
                  <div class="selectPlus1">
                    <label class="fixedSelect3">Modo de Aplicação</label>
                    <textarea
                      class="inputTextArea"
                      rows="3"
                      max-rows="6"
                      v-model="currentProduct.infortecnicaReceita.modoaplicacao"
                    />
                  </div>
                </div>
                <div class="rowContentMensagem" style="padding: 10px 0 5px 0">
                  <div class="selectPlus1">
                    <label class="fixedSelect3">EPI</label>
                    <textarea
                      class="inputTextArea"
                      rows="3"
                      max-rows="6"
                      v-model="dataPesticides.epi"
                    />
                  </div>
                </div>
                <div class="rowContentBtn">
                  <span
                    v-if="isLoadingToAddProd"
                    class="form-btn-calculator"
                    style="width: 100%; padding: 18px; gap: 10px"
                  >
                    <b-spinner class="spinProduct" /> Adicionando
                  </span>
                  <b-button
                    v-else
                    style="width: 100%; font-size: 14px; padding: 18px"
                    class="form-btn-calculator"
                    @click="handleAddItemsAndVerifyAlerts"
                    :disabled="isLoadingToAddProd"
                  >
                    {{
                      currentProduct.id
                        ? "Atualizar Agrotóxico"
                        : "Adicionar Agrotóxico"
                    }}</b-button
                  >
                </div>
                <div class="ContentTable" v-if="tableProducts.length > 0">
                  <div class="titleTable">
                    {{
                      tableProducts.filter(
                        (item) => item.typeProduct === "agrotoxicos"
                      ).length
                    }}
                    Agrotóxicos Adicionados
                  </div>

                  <div class="ContentTable">
                    <div
                      v-for="product in tableProducts.filter(
                        (agro) => agro.typeProduct === 'agrotoxicos'
                      )"
                      :key="product.id"
                      :class="`rowSupplier`"
                      @click.stop="editProductsOfSale(product)"
                    >
                      <div class="celTable" style="width: 20%">
                        <span>
                          <strong>Registro : </strong>
                          {{ product.infortecnicaReceita.registroAgrotox }}
                        </span>
                      </div>
                      <div class="celTable" style="width: 40%">
                        <span>
                          <strong>Nome Agrotóxico: </strong>
                          {{ product.nome }}
                        </span>
                      </div>
                      <div class="celTable" style="width: 15%">
                        <span>
                          <strong>Quantidade : </strong>
                          {{ product.quantidade }}
                        </span>
                      </div>
                      <div class="celTable" style="width: 30%">
                        <span>
                          <strong
                            >Sigla :
                            {{ product.infortecnicaReceita.embalagem }}</strong
                          >
                        </span>
                      </div>
                      <div class="celTableActions">
                        <span
                          style="font-size: 10px !important"
                          class="celInfos"
                          v-b-tooltip.hover.top="'Ver Detalhes Técnicos'"
                          v-b-modal.modal-receita
                          @click.stop="showProductDetails(product)"
                        >
                          <b-icon-eye-fill scale="1.5" />
                        </span>
                      </div>
                      <div class="celTableActions">
                        <span
                          v-if="!currentProduct || currentProduct.id !== product.id"
                          style="
                            font-size: 10px !important;
                            background-color: #7f7f7f;
                            color: #4b0000;
                          "
                          class="celInfos"
                          v-b-tooltip.hover.top="'Excluir Agrotóxico'"
                          @click.stop="openModalDeleteProduct(product)"
                        >
                          <b-icon-trash-fill scale="1.5" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="containerTotalsItems"
                  v-if="typeComponent !== 'Receita'"
                >
                  <div class="rowTotalsItems" style="max-width: 80px">
                    <div
                      class="boxTotalsItems"
                      style="background-color: #3b82ff40"
                    >
                      <b-icon-box-seam scale="1.3" style="color: blue" />
                    </div>

                    <div>
                      <p class="valueTotalsItems">
                        {{ objectTotals.byType.agrotoxicos.amountItems }}
                      </p>
                    </div>
                  </div>

                  <div class="rowTotalsItems">
                    <div
                      class="boxTotalsItems"
                      style="
                        background-color: rgb(15 191 77 / 22%);
                        font-size: 1rem;
                      "
                    >
                      $
                    </div>

                    <div>
                      <p style="margin: 0">Subtotal</p>
                      <p class="valueTotalsItems">
                        {{
                          maskCurrency(
                            objectTotals.byType.agrotoxicos.subtotalItems
                          )
                        }}
                      </p>
                    </div>
                  </div>

                  <div class="rowTotalsItems">
                    <div
                      class="boxTotalsItems"
                      style="background-color: oklch(0.93 0.08 75.11)"
                    >
                      <b-icon-patch-minus
                        scale="1.5"
                        style="color: rgb(255 0 0)"
                      />
                    </div>

                    <div>
                      <p style="margin: 0">Desconto</p>
                      <p class="valueTotalsItems">
                        {{
                          maskCurrency(
                            objectTotals.byType.agrotoxicos.totalDiscountItems
                          )
                        }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="rowTotalsItems"
                    style="box-shadow: 0 0 0 1.5px #12b8a4"
                  >
                    <div
                      class="boxTotalsItems"
                      style="
                        background-color: #12b8a4;
                        font-size: 1rem;
                        color: white;
                      "
                    >
                      $
                    </div>

                    <div>
                      <p style="margin: 0; font-weight: 600; color: #12b8a4">
                        Total
                      </p>
                      <p class="valueTotalsItems">
                        {{
                          maskCurrency(
                            objectTotals.byType.agrotoxicos.totalValueItems
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <ModalCreateProducts
      @getAllNewProduct="handleCreatedNewProduct"
      :idProductFromSearch="idProductFromSearch"
      modalName="modal-create-products"
    />

    <ModalCreateCustomerMobile
      @getAllNewCustomer="handleCreatedNewCustomer"
      :idCustomerFromSearch="sale.idCliente"
    />

    <ModalCreateEmployeesMobile
      @getAllNewEmployee="getEmployeesForSelectBox"
      :idEmployeeFromSearch="sale.idFuncionario"
    />

    <ModalCreateApplicators
      nameModal="modalCreateApplicatorMobile"
      @getAllNewApplicator="handleSavedApplicator"
      :idApplicatorFromSearch="sale.idAplicador"
    />

    <ModalCreateResponsible
      @getAllResponsibles="getAllResponsibles"
      :idResponsibleFromSearch="sale.idResponsavelTecnico"
    />

    <ModalCreateMenssagesMobile
      :defaultMessage="defaultMessage"
      @getNewMessage="getAllMessages"
    />

    <ModalActions
      modalName="modal-actions-prescription"
      :options="modalActionsPresctItems"
      :showGenerateOrder="false"
    />

    <ModalActions
      modalName="modal-actions-order"
      :options="modalActionsOrderItems"
      :showGenerateOrder="false"
    />

    <ModalDetailsProduct :product="selectedProductDetails" />

    <ModalConfirm
      modalName="modal-confirm-product"
      title="Excluir item"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="removeItens"
    />

    <ModalConfirm
      modalName="check-customer"
      title="Exibir dados do cliente na NFC-e ?"
      subtitle="Exibe CPF, nome e endereço do cliente na emissão."
      rightButtonText="Não"
      leftButtonText="Sim, exibir"
      typeModal="info"
      headerIcon="b-icon-patch-exclamation-fill"
      :rightButtonClick="() => sendCoupon(false)"
      :leftButtonClick="() => sendCoupon(true)"
    />

    <ModalConfirm
      modalName="modal-confirm-cancel-prescription"
      title="Cancelar Receita ?"
      subtitle="Esta ação irá cancelar a receita. O número da ART poderá ser reutilizado em uma nova emissão. Deseja realmente cancelar?"
      rightButtonText="Sim"
      leftButtonText="Não cancelar"
      :rightButtonClick="cancelSale"
    />

    <ModalConfirm
      modalName="transform-in-completed-sale"
      title="Converter para Pedido Completo?"
      subtitle="A receita será convertida de forma permanente em um Pedido Completo. Esta ação é irreversível e recomendada quando houver emissão de Nota Fisca. Para desfazer, será necessário cancelar o Pedido Completo e refazer a receita. "
      rightButtonText="Não, voltar"
      leftButtonText="Sim, converter"
      typeModal="info"
      headerIcon="b-icon-patch-exclamation-fill"
      :leftButtonClick="() => generateCompletedSale()"
    />

    <ModalConfirm
      modalName="reuse-prescription"
      title="Reutilizar esta numeração de receita ?"
      subtitle="Ao reutilizar a numeração, a receita cancelada permanece acessível e uma nova receita será criada com o mesmo número!"
      rightButtonText="Sim"
      leftButtonText="Não Reutilizar"
      typeModal="info"
      headerIcon="b-icon-patch-exclamation-fill"
      :rightButtonClick="() => handleReusePrescription()"
    />

    <ModalTaxInformation
      v-if="['Pedido', 'Receita Pedido'].includes(this.sale.tipo)"
      @createdNewRef="findAllRefs"
      @closeModal="handleCloseModalRef"
      :refFromSearch="refFromSearch"
    />

    <ModalCreateNcm @getNewNcm="ncmCombobox" />

    <div class="content-btn-fixed">
      <div style="width: 20%">
        <b-button
          v-if="sale.id && sale.status === 'Rascunho'"
          class="form-btn"
          style="background: rgb(74, 131, 153); width: 137px"
          :disabled="isSaveOrFinishLoading || hasInvalidInspectionProducts"
          @click="finishAndUpdatePrescription"
        >
          <b-spinner
            v-if="isLoadingToFinishPrescription"
            small
            class="mr-2"
          />
          Finalizar
        </b-button>

        <b-button
          v-if="sale.id && sale.status === 'Finalizado(a)'"
          class="form-btn"
          style="background: brown; width: 137px"
          @click="openModalCancelSale"
        >
          Cancelar
        </b-button>
      </div>

      <div style="display: flex; align-items: center">
        <b-button
          :style="`width: 190px; ${
            sale.status === 'Finalizado(a)' && 'border-radius: 3px;'
          }`"
          class="form-btn"
          :disabled="isSaveOrFinishLoading"
          @click="handleSubmit"
        >
          <b-spinner
            v-if="isLoadingToSavePrescription"
            small
            class="mr-2"
          />
          {{ inspectionPrescriptionSubmitLabel }}
        </b-button>

        <div
          class="btnActions"
          v-if="sale.status === 'Finalizado(a)' || sale.status === 'Cancelado'"
        >
          <b-dropdown
            id="dropdown-1"
            class="btnActions1"
            variant="none"
            size="sm"
          >
            <template #button-content>
              <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
            </template>

            <b-dropdown-item
              v-if="
                sale.status === 'Finalizado(a)' &&
                (typeComponent === 'Receita' ||
                  typeComponent === 'Receita Pedido')
              "
              style="font-size: 0.8rem"
              @click="printReportSelect(false)"
            >
              Imprimir Receita
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                sale.status === 'Finalizado(a)' &&
                canUseDigitalSignature &&
                (typeComponent === 'Receita' ||
                  typeComponent === 'Receita Pedido')
              "
              style="font-size: 0.8rem"
              @click="handleSignPrescription"
            >
              Assinar digitalmente
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                sale.status === 'Finalizado(a)' &&
                (typeComponent === 'Pedido' ||
                  typeComponent === 'Receita Pedido')
              "
              style="font-size: 0.8rem"
              @click="printReportVendaOrcamento"
            >
              Imprimir Recibo
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                sale.status === 'Finalizado(a)' &&
                (typeComponent === 'Pedido' ||
                  typeComponent === 'Receita Pedido')
              "
              style="font-size: 0.8rem"
              @click="handleTranformToNfeAndCloseModal"
            >
              Emitir NF-e
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                sale.status === 'Finalizado(a)' &&
                (typeComponent === 'Pedido' ||
                  typeComponent === 'Receita Pedido')
              "
              style="font-size: 0.8rem"
              @click="() => this.openModals('check-customer')"
            >
              Emitir NFC-e
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                sale.status === 'Cancelado' &&
                (typeComponent === 'Receita' ||
                  typeComponent === 'Receita Pedido')
              "
              style="font-size: 0.8rem"
              @click="() => this.openModals('reuse-prescription')"
            >
              Reutilizar numeração
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <b-modal id="alert-modal" size="md" hide-footer hide-header>
      <div class="containerAlertModal">
        <div class="btnCloseAlertModal" @click="closeModals('alert-modal')">
          X
        </div>

        <div style="display: flex; align-items: center; gap: 1rem">
          <div class="contentAlertIcon">
            <b-icon-exclamation-triangle
              style="color: oklch(66.6% 0.179 58.318)"
              scale="1.2"
            />
          </div>

          <div>
            <p style="margin: 0; color: black; font-size: 1.1rem">
              Alertas Detectados
            </p>

            <p
              style="
                margin: 0;
                color: oklch(44.6% 0.03 256.802);
                font-size: 0.82rem;
              "
            >
              Foram encontrados alguns alertas que requerem atenção
            </p>
          </div>
        </div>

        <div class="contentAlertItems">
          <div class="pesticideAlertArea" v-if="getPesticideRestriction">
            <b-icon-droplet-half
              style="color: rgb(32 76 163); width: 18px; height: 18px"
            />

            <div>
              <p
                style="
                  margin: 0;
                  line-height: 1.5;
                  color: rgb(32 76 163);
                  font-size: 0.9rem;
                  margin-bottom: 0.3rem;
                "
              >
                Agrotóxico:
                {{ getPesticideRestriction?.infortecnicaReceita?.agrotoxico }}
              </p>

              <p
                style="
                  margin: 0;
                  color: oklch(54.6% 0.245 262.881);
                  font-size: 0.78rem;
                  font-weight: 400;
                "
              >
                {{
                  getPesticideRestriction?.mensagemAlerta &&
                  getPesticideRestriction?.mensagemAlerta
                }}
              </p>
            </div>
          </div>

          <div class="cultureAlertArea" v-if="getCultureRestriction">
            <b-icon-tree-fill
              style="
                color: oklch(62.7% 0.194 149.214);
                width: 18px;
                height: 18px;
              "
            />

            <div>
              <p
                style="
                  margin: 0;
                  line-height: 1.5;
                  color: oklch(62.7% 0.194 149.214);
                  font-size: 0.9rem;
                  margin-bottom: 0.3rem;
                "
              >
                Cultura: {{ getCultureRestriction.nomeCultura }}
              </p>

              <p
                style="
                  margin: 0;
                  color: oklch(0.76 0.2 150.03);
                  font-size: 0.78rem;
                  font-weight: 400;
                "
              >
                {{
                  getCultureRestriction.observacao ||
                  "Cultura com restrições para o seu estado"
                }}
              </p>
            </div>
          </div>

          <div class="diagnosticAlertArea" v-if="getDiagnosticRestriction">
            <b-icon-bug
              style="
                color: oklch(64.6% 0.222 41.116);
                width: 18px;
                height: 18px;
              "
            />

            <div>
              <p
                style="
                  margin: 0;
                  line-height: 1.5;
                  color: oklch(64.6% 0.222 41.116);
                  font-size: 0.9rem;
                  margin-bottom: 0.3rem;
                "
              >
                Diagnóstico: {{ getDiagnosticRestriction.nomeComum }}
              </p>

              <p
                style="
                  margin: 0;
                  color: oklch(0.74 0.21 45.48);
                  font-size: 0.78rem;
                  font-weight: 400;
                "
              >
                {{
                  getDiagnosticRestriction.observacao ||
                  `Produto não Liberado para uso neste alvo biológico no estado ${ufCustomerProperty}`
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="contentBtnsAlertModal">
          <button @click="closeModals('alert-modal')">Cancelar</button>
          <button class="continueAlertBtn" @click="addProduct">
            Prosseguir
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="alert-modal-select-perticide"
      size="md"
      hide-footer
      hide-header
    >
      <div class="containerAlertModal">
        <div
          class="btnCloseAlertModal"
          @click="closeModals('alert-modal-select-perticide')"
        >
          X
        </div>

        <div style="display: flex; align-items: center; gap: 1rem">
          <div class="contentAlertIcon">
            <b-icon-exclamation-triangle
              style="color: oklch(66.6% 0.179 58.318)"
              scale="1.2"
            />
          </div>

          <div>
            <p style="margin: 0; color: black; font-size: 1.1rem">
              Alerta Detectado
            </p>

            <p
              style="
                margin: 0;
                color: oklch(44.6% 0.03 256.802);
                font-size: 0.82rem;
              "
            >
              Identificamos uma ocorrência que requer a sua atenção.
            </p>
          </div>
        </div>

        <div class="contentAlertItems">
          <div class="pesticideAlertArea" v-if="getPesticideRestriction">
            <b-icon-droplet-half
              style="color: rgb(32 76 163); width: 18px; height: 18px"
            />

            <div>
              <p
                style="
                  margin: 0;
                  line-height: 1.5;
                  color: rgb(32 76 163);
                  font-size: 0.9rem;
                  margin-bottom: 0.3rem;
                "
              >
                Agrotóxico:
                {{ getPesticideRestriction?.infortecnicaReceita?.agrotoxico }}
              </p>

              <p
                style="
                  margin: 0;
                  color: oklch(54.6% 0.245 262.881);
                  font-size: 0.78rem;
                  font-weight: 400;
                "
              >
                {{
                  getPesticideRestriction?.mensagemAlerta &&
                  getPesticideRestriction?.mensagemAlerta
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="contentBtnsAlertModal">
          <button
            class="continueAlertBtn"
            @click="closeModals('alert-modal-select-perticide')"
          >
            Prosseguir
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="alert-modal-select-aplication"
      size="md"
      hide-footer
      hide-header
    >
      <div class="containerAlertModal">
        <div
          class="btnCloseAlertModal"
          @click="closeModals('alert-modal-select-aplication')"
        >
          X
        </div>

        <div style="display: flex; align-items: center; gap: 1rem">
          <div class="contentAlertIcon">
            <b-icon-exclamation-triangle
              style="color: oklch(66.6% 0.179 58.318)"
              scale="1.2"
            />
          </div>

          <div>
            <p style="margin: 0; color: black; font-size: 1.1rem">
              Alerta Detectado
            </p>

            <p
              style="
                margin: 0;
                color: oklch(44.6% 0.03 256.802);
                font-size: 0.82rem;
              "
            >
              Identificamos uma ocorrência que requer a sua atenção.
            </p>
          </div>
        </div>

        <div class="contentAlertItems">
          <div class="pesticideAlertArea" v-if="getAplicationRestriction">
            <b-icon-droplet-half
              style="color: rgb(32 76 163); width: 18px; height: 18px"
            />

            <div>
              <p
                style="
                  margin: 0;
                  line-height: 1.5;
                  color: rgb(32 76 163);
                  font-size: 0.9rem;
                  margin-bottom: 0.3rem;
                "
              >
                Tipo Aplicação:
                {{ getAplicationRestriction?.nome }}
              </p>

              <p
                style="
                  margin: 0;
                  color: oklch(54.6% 0.245 262.881);
                  font-size: 0.78rem;
                  font-weight: 400;
                "
              >
                {{ getAplicationRestriction?.mensagemAlerta }}
              </p>
            </div>
          </div>
        </div>

        <div class="contentBtnsAlertModal">
          <button
            class="continueAlertBtn"
            @click="closeModals('alert-modal-select-aplication')"
          >
            Prosseguir
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-mobile-unavailable"
      size="sm"
      hide-footer
      hide-header
      centered
    >
      <div class="modal-mobile-unavailable-content">
        <div
          class="btnCloseAlertModal"
          @click="closeModals('modal-mobile-unavailable')"
        >
          X
        </div>

        <div class="modal-mobile-unavailable-header">
          <b-icon-exclamation-triangle
            style="color: #f59e0b; font-size: 2.5rem"
          />
          <h3>Atenção!</h3>
        </div>

        <div class="modal-mobile-unavailable-body">
          <p>Funcionalidade indisponível no mobile.</p>
          <p>Acesse pelo computador para concluir a venda.</p>
        </div>

        <div class="modal-mobile-unavailable-footer">
          <button
            class="btn-understood"
            @click="closeModals('modal-mobile-unavailable')"
          >
            Entendi
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { DateTime } from "luxon";
import moment from "moment";

import ModalCreateCustomerMobile from "../Modals/ModalCreateCustomerMobile.vue";
import ModalCreateProducts from "../Modals/ModalCreateProduct.vue";
import ModalCreateEmployeesMobile from "../Modals/ModalCreateEmployeesMobile.vue";
import ModalCreateApplicators from "../Modals/ModalCreateApplicators.vue";
import ModalCreateMenssagesMobile from "../Modals/ModalCreateMenssagesMobile.vue";
import ModalCreateResponsible from "../Modals/ModalCreateResponsible.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import ModalActions from "./ModalActions.vue";
import ModalDetailsProduct from "./ModalDetailsProduct.vue";
import ModalTaxInformation from "../../components/ModalTaxInformation/Index-TaxInformation.vue";
import ItemManualTax from "../../components/ModalTaxInformation/ItemManualTax.vue";
import ModalCreateNcm from "../Modals/ModalCreateNcm.vue";

import Input from "../UI/CustomInputs/Input.vue";
import ApplicationPeriodInput from "./ApplicationPeriodInput.vue";
import { cultureStages } from "../../utils/cultureStages";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import InputSearchSelect from "../UI/CustomInputs/InputSearchSelect.vue";
import InputSelectStock from "../UI/CustomInputs/InputSelectStock.vue";
import InputMoney from "../UI/CustomInputs/InputMoney.vue";
import InputPercentage from "../UI/CustomInputs/InputPercentage.vue";
import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue";
import InputProducts from "../../components/UI/CustomInputs/InputProducts.vue";
import SimpleProductsMobile from "./SimpleProductsMobile.vue";
import { prescriptionProductError } from "./prescriptionProductRules";
import AdditionalInformation from "./AdditionalInformation.vue";

import serviceSale from "../../services/serviceSale";
import serviceCustomer from "../../services/serviceCustomer";
import serviceEmployee from "../../services/serviceEmployees";
import serviceApplicators from "../../services/serviceApplicators";
import serviceProducts from "../../services/serviceProducts";
import ServiceCompendio from "../../services/serviceCompendio";
import servicePaymentForm from "../../services/servicePaymentForm";
import serviceMessages from "../../services/serviceMessages";
import serviceCustomerProperty from "../../services/serviceCustomerProperty";
import serviceResponsible from "../../services/serviceResponsible";
import serviceProductSale from "../../services/serviceProductSale";
import serviceInspection from "../../services/serviceInspection";
import {
  extractInspectionPrescriptionOrigin,
  inspectionProductNeedsReview,
  inspectionPrescriptionMissingFields as getInspectionPrescriptionMissingFields,
  removeInspectionPrescriptionTransientFields,
} from "../InspectSearch/inspectionPrescription";
import serviceNotaFiscal from "../../services/serviceNotaFiscal";
import serviceTax from "../../services/serviceTax";
import serviceNcms from "../../services/serviceNcms";

import { mascaraMoeda, maskCurrency } from "../../utils/maskMoney";
import { removeReference } from "../../utils/removeReference";
import { applyItemTaxFromRef, createManualTax, ensureItemTax } from "../../utils/itemTax";
import toastAlertErros from "../../utils/toastAlertErros";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { HandleErrors } from "../../utils/handleErrors";
import { calculateProductQuantity } from "../../utils/calculateProductQuantity";
import { hasDigitalSignaturePermission } from "../../utils/digitalSignaturePermission";
import print from "../../reports/sale";

const createEmptySale = () => ({
  id: null,
  idEmpresa: "",
  idCliente: "",
  idFuncionario: null,
  idAplicador: null,
  idResponsavelTecnico: "",
  idPropriedade: null,
  idInspecao: null,
  idRefReceita: null,
  data: DateTime.local().toISODate(),
  dataVencimento: DateTime.local().toISODate(),
  dataNfe: null,
  dataEntrega: null,
  dadosAdicionais: "",
  observacoesNf: "",
  status: "Rascunho",
  tipo: "Receita",
  saleType: "Venda",
  tipoDesconto: "Valor Monetário",
  frete: 0,
  outrosValores: 0,
  numero: 0,
  comissao: 0,
  receita: 0,
  numeroNFe: 0,
  serieNFe: 0,
  serieSC: 0,
  valor: 0,
  art: null,
  complementoReceita: null,
  statusSC: null,
  codRetSC: null,
  enviado: null,
  devolucao: null,
  codGoias: null,
  protocoloES: null,
  protocoloCancelamentoES: null,
  chaveNFe: null,
  numeroOrdem: null,
  jsonSC: null,
  observacoesReceita: null,
  mip: null,
  situacaoReceita: "nao_enviada",
  tipoReceita: "normal",
  products: [],
  bills: [],
});

const createEmptyProduct = () => ({
  id: "",
  idVenda: "",
  idProduto: "",
  dadosAdicionais: "",
  typeProduct: "agrotoxicos",
  quantidade: 1,
  valorUnitario: 0,
  desconto: 0,
  valorTotal: 0,
  classe_imposto: null,
  imposto_manual: createManualTax(),
  usar_imposto_manual: false,
  ncm: null,
  infortecnicaReceita: {
    registroAgrotox: "",
    idAgrotoxico: "",
    lote: "",
    agrotoxico: "",
    idEmbalagem: "",
    embalagem: "",
    idCultura: "",
    cultura: {
      id: "",
      nome: "",
      nomecientifico: "",
      idfamiliacultura: "",
      informacoes: "",
      caracteristicas: "",
      clima: "",
      solo: "",
      epoca_plantio: "",
      epoca_colheita: "",
      produtividade: "",
      pragas_doencas: "",
      link_video: "",
      cod_sc: "",
      cod_rs: "",
      cod_mt: "",
      ncm: "",
      cod_es: "",
    },
    nomeCultura: "",
    idProblema: "",
    idIndicacao: "",
    nomeProblema: "",
    nomeProblemaCientifico: "",
    doseBula: "",
    doseUtilizada: "",
    volumeCaldaBula: "",
    volumeCaldaUtilizado: "",
    intervaloAplicacao: 0,
    intervaloSeguranca: "",
    maxAplicacoesBula: 0,
    numAplicacoes: 1,
    estagioCultura: "",
    formaAplicacao: "",
    epocaAplicacao: "",
    doseSelectionMode: "intervalo",
    volumeCaldaSelectionMode: "intervalo",
    areatratar: 1,
    medida: "ha",
    modaplicacao: "",
    modoaplicacao: "",
    idTipoAplicacao: null,
    nomeTipoAplicacao: "",
    tipoAplicacao: {
      id: "",
      nome: "",
      codMt: "",
      codEs: "",
    },
    horario: "",
  },
});

export default {
  components: {
    ModalCreateCustomerMobile,
    ModalCreateEmployeesMobile,
    ModalCreateApplicators,
    ModalCreateProducts,
    ModalCreateMenssagesMobile,
    ModalCreateResponsible,
    ModalActions,
    ModalConfirm,
    ModalDetailsProduct,
    ModalTaxInformation,
    ItemManualTax,
    ModalCreateNcm,
    InputSelect,
    InputSearchSelect,
    InputSelectStock,
    InputMoney,
    InputPercentage,
    Input,
    ApplicationPeriodInput,
    InputInfinit,
    InputProducts,
    SimpleProductsMobile,
    AdditionalInformation,
  },
  props: {
    prescriptionId: {
      type: String,
      default: null,
    },
    typeComponent: {
      type: String,
      default: "Receita",
    },
  },
  data() {
    return {
      cultureStages,
      sale: { ...createEmptySale(), tipo: this.typeComponent },
      currentProduct: createEmptyProduct(),
      dataProducts: [],
      dataCustomers: [],
      dataEmployees: [],
      dataApplicators: [],
      dataProperties: [],
      dataCultures: [],
      dataTargets: [],
      dataAplications: [],
      dataTechnicalManagers: [],
      selectedProductDetails: null,
      getAllProducts: null,
      createdNewCustomer: null,
      createdNewProducts: null,
      products: [],
      refFromSearch: "",
      dataPrescription: {
        id_receita: "",
        id_cliente: "",
        id_propriedade: "ccd80485-fd17-4054-8463-430de022efe0",
        id_responsavel: "",
        numeroreceita: "",
        numeroart: "",
        data: "",
        statusreceita: "Aberto",
        observacao: "",
        obsmip: "",
        notafiscal: "",
        serie: "",
        ordem: "",
        valor: 0,
        datafinal: "",
        statussc: "",
        jsonsc: "",
        codretsc: "",
        enviado: "",
        devolução: "",
        cogoias: "",
        seriesc: "",
        complementoreceita: "",
        chavenfe: "",
        protocolors: "",
        protocolocancelamentors: "",
        contrato: "",
        nomecliente: "",
        nomeresponsavel: "",
        datanfe: "",
      },
      dataPesticides: {
        id_infortecnica: "",
        id_receita: "",
        aplicacao: "",
        areatratar: "",
        classetoxico: "",
        classificacaocultura: "",
        codcultura: "",
        concentracao: "",
        dosagem: "",
        epi: "",
        epocaaplicacao: "",
        estagiocultura: "",
        fitoxidade: "",
        formulacao: "",
        horario: "",
        nomeembalagem: "",
        tipoembalagem: "",
        unidademmbalagem: "",
        indicacao: "",
        ingredienteativo: "",
        Intervaloaplicacao: "",
        intervaloseguranca: "",
        lote: "",
        id_agrotoxico: 0,
        id_cultura: 0,
        modaplicacao: "",
        nomeagrotoxico: "",
        nomecultura: "",
        nomeclasse: "",
        nomeclasseambiental: "",
        nomegrupoquimico: "",
        problemacientifico: "",
        problemacomum: "",
        quantembal: "",
        quantidadeadquirir: "",
        registroagrotoxico: "",
        idTipoAplicacao: "",
        volumecalda: "",
        volumecaldabula: "",
        dosagembula: "",
        intervaloentrada: "",
        modoaplicacao: "",
      },
      idProductFromSearch: "",
      dataLotes: [],
      currentProductStock: null,
      medida: [
        { value: "ha", text: "Ha" },
        { value: "ton", text: "Ton" },
        { value: "m3", text: "M³" },
        { value: "m2", text: "M²" },
        { value: "", text: "Selecione..." },
      ],
      prescriptionStatusOptions: [
        { value: "enviada", text: "enviada" },
        { value: "enviada_parcialmente", text: "Parcial" },
        { value: "nao_enviada", text: "Não Enviada" },
      ],
      activeSection: 1,
      selectedTabLabel: "prescription",
      tabs: [
        { value: "order", text: "Pedido" },
        { value: "additional_information", text: "Pagamentos" },
      ],
      newOrder: false,
      toggleClearSelect: false,
      isPrescriptionSectionCollapsed: false,
      maskCurrency: maskCurrency,
      mascaraMoeda: mascaraMoeda,
      objectTotals: {
        totalOfItens: 0,
        totalOfDiscount: 0,
        totalOfSale: 0,
        byType: {
          agrotoxicos: {
            agrotoxicos: 0,
            totalValueItems: 0,
            totalDiscountItems: 0,
            subtotalItems: 0,
          },
          simples: {
            amountItems: 0,
            totalValueItems: 0,
            totalDiscountItems: 0,
            subtotalItems: 0,
          },
        },
      },
      additionalValues: "R$ 0,00",
      totalValue: 0,
      allPaymentsTypes: [],
      intervaloDias: "",
      totalParcelas: 1,
      dataBillBySale: {
        tipo: "entrada",
        idCliente: "",
        idFuncionario: "",
        idFormaPagamento: "",
        idContaRecebimento: "",
        idVenda: "",
        valorUnitario: 0.0,
        valorPago: 0.0,
        valorRestante: 0.0,
        data: moment().format("YYYY-MM-DD"),
      },
      moreInfoPesticides: null,
      idPesticide: null,
      registro: "",
      selectedCultureData: null,
      selectedDiagnosticData: null,
      selectedTech: null,
      listEmbs: [],
      tableProducts: [],
      pendingInspectionProducts: [],
      inspectionOrigin: null,
      isImportingInspectionProducts: false,
      messages: {
        geral: [{ id: "", titulo: "Selecione..." }],
        mip: [{ id: "", titulo: "Selecione..." }],
      },
      descriptionItems: {
        aplicationMethod: "",
        pesticide: "",
        culture: "",
        indicacao: "",
      },
      ufCustomerProperty: "",
      isCultureDiagsClared: false,
      aplicationRestriction: null,
      defaultMessage: "geral",
      idToDeleteItem: null,
      allRefsFiscais: [],
      modalActionsPresctItems: {
        header: {
          icon: "b-icon-printer",
          styleIcon: "width: 20px; height: 20px; color: white",
          backIconColor: null,
          title: "Deseja imprimir ?",
          subtitle: "Escolha como você gostaria de processar esta receita",
        },
        buttons: [
          {
            icon: "b-icon-printer",
            styleIcon: "width: 16px; height: 16px; color: black",
            backIconColor: "background-color: #8080802b",
            title: "Imprimir",
            subtitle: "Apenas imprimir a receita",
            click: () => this.printReportSelect(false),
          },
          {
            icon: "b-icon-vector-pen",
            styleIcon: "width: 16px; height: 16px; color: white",
            backIconColor: "background-color: rgb(74, 131, 153)",
            title: "Assinar Digitalmente",
            subtitle: "Adicionar assinatura digital",
            click: () => this.handleSignPrescription(),
            hoverColor: "colorSuccess",
            show: hasDigitalSignaturePermission(
              this.typeComponent === "Receita Pedido"
                ? "novoPedidoCompleto"
                : "novaReceita"
            ),
          },
          {
            icon: "b-icon-file-earmark-medical",
            styleIcon: "width: 16px; height: 16px; color: white",
            backIconColor: "background-color: rgb(74 153 100)",
            title: "Imprimir e Assinar Digitalmente",
            subtitle: "Imprimir e adicionar assinatura",
            click: () => this.handleSignPrescription(),
            hoverColor: "colorInfo",
            show: hasDigitalSignaturePermission(
              this.typeComponent === "Receita Pedido"
                ? "novoPedidoCompleto"
                : "novaReceita"
            ),
          },
        ],
        footer: {
          button: {
            icon: "b-icon-file-earmark-text",
            title: "Gerar pedido completo",
            click: () => this.openModals("transform-in-completed-sale"),
          },
        },
      },
      modalActionsOrderItems: {
        header: {
          icon: "b-icon-printer",
          styleIcon: "width: 20px; height: 20px; color: white",
          backIconColor: null,
          title: "Deseja imprimir ?",
          subtitle: "Escolha como você gostaria de processar este pedido",
        },
        buttons: [
          {
            icon: "b-icon-printer",
            styleIcon: "width: 16px; height: 16px; color: black",
            backIconColor: "background-color: #8080802b",
            title: "Imprimir Recibo",
            subtitle: "Impressão rápida sem vínculo fiscal",
            click: this.printReportVendaOrcamento,
          },
          {
            icon: "b-icon-file-earmark-text-fill",
            styleIcon: "width: 16px; height: 16px; color: white",
            backIconColor: "background-color: rgb(74, 131, 153)",
            title: "Emitir NF-e",
            subtitle: "Gere uma NF-e e realize a emissão.",
            click: this.handleTranformToNfeAndCloseModal,
            hoverColor: "colorSuccess",
          },
          {
            icon: "b-icon-file-text-fill",
            styleIcon: "width: 16px; height: 16px; color: white",
            backIconColor: "background-color: rgb(74 153 100)",
            title: "Emitir NFC-e",
            subtitle: "Gere uma NFC-e e realize a emissão.",
            click: () => this.openModals("check-customer"),
            hoverColor: "colorInfo",
          },
        ],
        footer: {
          button: {
            icon: "b-icon-file-earmark-text",
            title: "Gerar pedido completo",
            click: () => this.openModals("transform-in-completed-sale"),
          },
        },
      },
      reusePrescription: false,
      originalResponsible: { id: null, receita: null, serieSC: null },
      infoProd: [],
      listNcms: [],
      isLoadingToAddProd: false,
      isLoadingToSavePrescription: false,
      isLoadingToFinishPrescription: false,
      currentStep: 0,
      steps: [
        { label: "Geral", id: "geral" },
        { label: "Receita", id: "receita" },
        { label: "Produtos", id: "produtos" },
      ],
      transitionName: "slide-next",
      savedScrollY: 0,
      bodyStyleBeforeLock: {
        position: "",
        top: "",
        left: "",
        right: "",
        width: "",
        overflow: "",
      },
      htmlStyleBeforeLock: {
        overflow: "",
      },
      isBodyScrollLocked: false,
    };
  },
  computed: {
    ...mapState({
      dataSearchFromSale: (state) => state.dataSearchFromSale,
      dataConfig: (state) => state.dataConfig,
      dataCompany: (state) => state.dataCompany,
      discountIsChecked: (state) => state.discountIsChecked,
    }),
    isEditing() {
      return !!this.sale.id;
    },
    isSaveOrFinishLoading() {
      return (
        this.isLoadingToSavePrescription || this.isLoadingToFinishPrescription
      );
    },
    canUseDigitalSignature() {
      const permissionType =
        this.typeComponent === "Receita Pedido"
          ? "novoPedidoCompleto"
          : "novaReceita";
      return hasDigitalSignaturePermission(permissionType);
    },
    getCompanyUf() {
      return this.dataCompany?.uf?.toUpperCase() || "";
    },
    getCultureRestriction() {
      if (!this.selectedCultureData) return null;

      const {
        cultura: { restricoesCultura = [] },
        nomeCultura,
      } = this.selectedCultureData;

      if (!restricoesCultura.length) return null;

      const { uf, tipoRestricao, observacao } = restricoesCultura[0];

      return uf === this.ufCustomerProperty
        ? { uf, tipoRestricao, observacao, nomeCultura }
        : null;
    },
    getPesticideRestriction() {
      if (this.currentProduct?.mensagemAlerta) {
        return this.currentProduct;
      }

      return null;
    },
    getDiagnosticRestriction() {
      if (!this.selectedDiagnosticData) return null;

      const {
        restricoes = [],
        nomeComum,
        nomeCientifico,
      } = this.selectedDiagnosticData;

      if (!restricoes.length) return null;

      const { uf, tipoRestricao, observacao } = restricoes[0];

      return uf === this.ufCustomerProperty
        ? { uf, tipoRestricao, observacao, nomeComum, nomeCientifico }
        : null;
    },
    getAplicationRestriction() {
      return this.aplicationRestriction;
    },
    getPrescriptionId() {
      return this.sale.idPropriedade;
    },
    handleDisabledCultureDiags() {
      if (!this.currentProduct.id) {
        return false;
      } else if (this.currentProduct.id && !this.isCultureDiagsClared) {
        return true;
      } else if (this.currentProduct.id && this.isCultureDiagsClared) {
        return false;
      }

      return false;
    },
    validatorDesc() {
      let existsDiscount = false;

      if (this.tableProducts.length) {
        for (const product of this.tableProducts) {
          if (product.desconto) {
            existsDiscount = true;
            break;
          }
        }
      }

      return existsDiscount;
    },
    verifyIfContainsPrescription() {
      if (
        this.typeComponent === "Receita" ||
        this.typeComponent === "Receita Pedido"
      )
        return true;

      return false;
    },
    remainingPrescriptions() {
      return this.selectedTech?.quantidadeReceita - 1 || 0;
    },
    getComponenteTitle() {
      if (this.typeComponent === "Receita") return "Receita Agronômica";
      else if (this.typeComponent === "Receita Pedido")
        return "Pedido Completo";
      else return "Pedido Simples";
    },
    getButtonTitle() {
      if (this.typeComponent === "Receita") return "Receita";
      else if (this.typeComponent === "Receita Pedido") return "Pedido";
      else return "Pedido";
    },
    missingInspectionPrescriptionFields() {
      return getInspectionPrescriptionMissingFields(this.sale, this.dataConfig);
    },
    hasInvalidInspectionProducts() {
      return (
        Boolean(this.inspectionOrigin) &&
        this.pendingInspectionProducts.some(inspectionProductNeedsReview)
      );
    },
    inspectionPrescriptionSubmitLabel() {
      if (this.inspectionOrigin && !this.sale.id) {
        const productCount = this.pendingInspectionProducts.length;
        return productCount
          ? `Gerar receita e adicionar ${productCount} produto(s)`
          : "Gerar receita";
      }

      return `${this.sale.id ? "Atualizar" : "Salvar"} ${this.getButtonTitle}`;
    },
    stepProgressWidth() {
      if (this.steps.length <= 1) return "0%";

      const progress = (this.currentStep / (this.steps.length - 1)) * 100;
      return `${progress}%`;
    },
  },
  methods: {
    ...mapMutations([
      "SET_DATA_NFE",
      "SET_DATA_SEARCH_FROM_SALE",
      "SET_SALE_ID",
      "TOGGLE_DISCOUNT",
      "SET_HTML_TO_PRINT",
      "SET_ID_TRANSFORM_COMPLETED_SALE",
    ]),
    lockBodyScroll() {
      if (this.isBodyScrollLocked) return;

      const bodyStyle = document.body.style;
      const htmlStyle = document.documentElement.style;

      this.savedScrollY = window.scrollY || window.pageYOffset || 0;

      this.bodyStyleBeforeLock = {
        position: bodyStyle.position,
        top: bodyStyle.top,
        left: bodyStyle.left,
        right: bodyStyle.right,
        width: bodyStyle.width,
        overflow: bodyStyle.overflow,
      };

      this.htmlStyleBeforeLock = {
        overflow: htmlStyle.overflow,
      };

      bodyStyle.position = "fixed";
      bodyStyle.top = `-${this.savedScrollY}px`;
      bodyStyle.left = "0";
      bodyStyle.right = "0";
      bodyStyle.width = "100%";
      bodyStyle.overflow = "hidden";
      htmlStyle.overflow = "hidden";

      this.isBodyScrollLocked = true;
    },
    unlockBodyScroll() {
      if (!this.isBodyScrollLocked) return;

      const bodyStyle = document.body.style;
      const htmlStyle = document.documentElement.style;

      bodyStyle.position = this.bodyStyleBeforeLock.position;
      bodyStyle.top = this.bodyStyleBeforeLock.top;
      bodyStyle.left = this.bodyStyleBeforeLock.left;
      bodyStyle.right = this.bodyStyleBeforeLock.right;
      bodyStyle.width = this.bodyStyleBeforeLock.width;
      bodyStyle.overflow = this.bodyStyleBeforeLock.overflow;

      htmlStyle.overflow = this.htmlStyleBeforeLock.overflow;

      window.scrollTo(0, this.savedScrollY || 0);

      this.isBodyScrollLocked = false;
    },
    goNextStep() {
      if (this.currentStep < this.steps.length - 1) {
        this.transitionName = "slide-next";
        this.currentStep++;
      }
    },
    goPrevStep() {
      if (this.currentStep > 0) {
        this.transitionName = "slide-prev";
        this.currentStep--;
      }
    },
    togglePrescriptionSection() {
      this.isPrescriptionSectionCollapsed =
        !this.isPrescriptionSectionCollapsed;
    },
    applyDefaultSaleObservations() {
      if (
        !this.sale.id &&
        !this.prescriptionId &&
        ["Pedido", "Receita Pedido"].includes(this.sale.tipo) &&
        !this.sale.dadosAdicionais
      ) {
        this.sale.dadosAdicionais =
          this.dataConfig?.venda?.dados_adicionais_padrao || "";
      }
    },
    async loadInitialData() {
      this.getEmployeesForSelectBox();
      await this.getApplicatorsForSelectBox();

      if (this.verifyIfContainsPrescription) {
        this.fillPesticidesComboBoxWithPaginate();
      }

      if (this.prescriptionId) {
        await this.loadPrescriptionForEdit(this.prescriptionId);
      }
    },
    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
    },
    async getEmployeesForSelectBox() {
      try {
        const { data } = await serviceEmployee.getEmployeesForSelectBox();
        this.dataEmployees = data;
      } catch (error) {
        this.$toast.error("Falha ao carregar funcionários.");
      }
    },
    async getApplicatorsForSelectBox(selectedId = this.sale.idAplicador) {
      try {
        const { data } = await serviceApplicators.getApplicatorsForSelectBox();
        if (selectedId && !data.some((item) => item.id === selectedId)) {
          const selected = await serviceApplicators.findById(selectedId);
          data.push(selected);
        }
        this.dataApplicators = data;
      } catch (error) {
        this.$toast.error("Falha ao carregar aplicadores.");
      }
    },
    async handleSavedApplicator(id) {
      await this.getApplicatorsForSelectBox(id);
      this.sale.idAplicador = id;
      if (this.$refs.aplicador) this.$refs.aplicador.valueItems = id;
    },
    goToSection(section) {
      this.activeSection = section;
    },
    async fillPesticidesComboBoxWithPaginate(id, q, filterType, page) {
      try {
        const { data } = await ServiceCompendio.combobox(
          id,
          q,
          filterType,
          page,
          "agrotoxicos"
        );

        return data?.map((agro) => {
          return {
            id: agro.id,
            nome: agro.nomeComum,
            registro: agro.registro,
            aplicacao: agro.aplicacao,
            mensagemAlerta: agro.mensagemAlerta,
          };
        });
      } catch (error) {
        this.$toast.error("Falha ao carregar produtos (agrotóxicos).");
      }
    },
    async fillCustomerComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await serviceCustomer.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os clientes",
          type: "info",
        });
      }
    },
    async findLotes(idAgrotoxico, idEmbalagem, registroAgrotox) {
      const result = await serviceProducts.findLotes(
        idAgrotoxico,
        idEmbalagem,
        registroAgrotox
      );

      this.dataLotes = result?.lotes || [];
      this.currentProductStock = (result?.infoProd || []).reduce(
        (total, product) => total + Number(product.estoque || 0),
        0
      );

      if (Object.keys(result?.infoProd || {}).length) {
        this.infoProd = result?.infoProd;

        this.currentProduct.valorUnitario = result?.infoProd[0].valorVenda;
        this.$refs.valorUnitario.valueInput = result?.infoProd[0].valorVenda;

        this.currentProduct.ncm = result?.infoProd[0].ncm;
        this.$refs.ncm.valueItems = result?.infoProd[0].ncm;

        this.currentProduct.classe_imposto = result?.infoProd[0].refFiscal;
        this.assignCurrentItemTaxFromRef(result?.infoProd[0].refFiscal);
        this.$refs.classe_imposto.valueItems =
          result?.infoProd[0].refFiscal;
      }
    },
    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },
    handleDataCustomers(event) {
      if (event) {
        this.dataCustomers = [event];
        this.getAllPropertys(this.dataCustomers[0].id);
      }
    },
    handleDataTech(id) {
      this.selectedTech = this.dataTechnicalManagers.find(
        (tech) => tech.id === id
      );

      if (!this.selectedTech) return;

      this.sale.art = this.selectedTech.art;
      this.$refs.art.valueInput = this.selectedTech.art;

      if (
        this.sale.id &&
        this.originalResponsible.id === this.selectedTech.id
      ) {
        this.sale.receita = this.originalResponsible.receita;
        this.$refs.receita.valueInput = this.originalResponsible.receita;
      } else {
        this.sale.receita = this.selectedTech.receita;
        this.$refs.receita.valueInput = this.selectedTech.receita;
      }

      this.sale.complementoReceita = this.selectedTech.complementoReceita;
      this.$refs.complementoReceita.valueInput =
        this.selectedTech.complementoReceita;

      if (this.getCompanyUf === "SC") {
        this.sale.serieSC =
          this.sale.id &&
          this.originalResponsible.id === this.selectedTech.id
            ? this.originalResponsible.serieSC
            : this.selectedTech.serieSC;

        if (this.$refs.serieSC) {
          this.$refs.serieSC.valueInput = this.sale.serieSC;
        }
      }

      this.dataTechnicalManagers = this.dataTechnicalManagers.filter(
        (tech) => tech.status === "ativo" || tech.id === id
      );
    },
    async handlePesticideSelection(pesticide) {
      if (!this.sale.idPropriedade) {
        this.toggleClearSelect = !this.toggleClearSelect;
        this.currentProduct.infortecnicaReceita.idAgrotoxico = "";

        return this.$toast.open({
          message:
            "(Cliente) e (Propriedade) devem ser selecionados para prosseguir",
          type: "info",
        });
      }

      this.clearDependentData();

      if (!pesticide || !pesticide.id) return;

      if (
        this.currentProduct.infortecnicaReceita.registroAgrotox !==
          pesticide.registro ||
        !pesticide.id
      ) {
        this.handleClearInfortecnicaReceitaWithoutAgrotoxico();
      }

      this.idPesticide = pesticide.id;
      this.currentProduct.infortecnicaReceita = {
        ...this.currentProduct.infortecnicaReceita,
        idAgrotoxico: pesticide.id,
        registroAgrotox: pesticide.registro,
        agrotoxico: pesticide.nome,
      };

      this.currentProduct = {
        ...this.currentProduct,
        mensagemAlerta: pesticide.mensagemAlerta,
      };

      if (
        (!this.currentProduct.infortecnicaReceita.idCultura &&
          !this.currentProduct.infortecnicaReceita.idIndicacao) ||
        this.currentProduct.infortecnicaReceita.registroAgrotox !==
          pesticide.registro
      ) {
        await this.fetchCultures(pesticide.id);
      } else {
        const prescriptionProblem =
          this.currentProduct.infortecnicaReceita.problema || {};

        this.dataCultures = [
          {
            nome: this.currentProduct.infortecnicaReceita.nomeCultura,
            idCultura: this.currentProduct.infortecnicaReceita.idCultura,
          },
        ];

        this.$refs.idCultura.valueItems =
          this.currentProduct.infortecnicaReceita.idCultura;

        await this.handleCultureSelection(
          this.currentProduct.infortecnicaReceita.cultura
        );

        this.dataTargets = [
          {
            idIndicacao:
              prescriptionProblem.idIndicacao ||
              this.currentProduct.infortecnicaReceita.idIndicacao,
            idProblema: this.currentProduct.infortecnicaReceita.idProblema,
            nomeComum: this.currentProduct.infortecnicaReceita.nomeProblema,
            masterName: `${this.currentProduct.infortecnicaReceita.nomeProblema} (${prescriptionProblem.nomeCientifico || this.currentProduct.infortecnicaReceita.nomeProblemaCientifico})`,
          },
        ];

        this.$refs.idIndicacao.valueItems =
          prescriptionProblem.idIndicacao ||
          this.currentProduct.infortecnicaReceita.idIndicacao;
      }

      const embalagensCompendio =
        await ServiceCompendio.findAllEmbalagensByIdAgrotoxico(
          this.idPesticide
        );

      const prods = await serviceProducts.findPerRegister(pesticide.registro);
      const embalagensEmEstoque = new Set(
        prods.filter((prod) => prod.estoque > 0).map((prod) => prod.embalagem)
      );

      this.listEmbs = embalagensCompendio.map((item) => ({
        ...item,
        inStock: embalagensEmEstoque.has(item.descricao),
      }));

      await this.fetchApplicationMethods(pesticide.id);

      this.descriptionItems.pesticide = pesticide?.aplicacao
        ?.replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n");

      this.handleAssingEpi(pesticide?.classificacao || null);
    },

    async fetchCultures(pesticideId) {
      try {
        const result = await ServiceCompendio.findApplicationsByCrop(
          pesticideId,
          this.ufCustomerProperty
        );

        if (Array.isArray(result)) {
          this.dataCultures = result
            .map((app) => ({
              ...app,
              nome: app.cultura.nome,
            }))
            .sort((a, b) => a.nome.localeCompare(b.nome));
          this.$toast.clear();
        } else {
          this.dataCultures = [];
        }
      } catch (error) {
        this.$toast.error("Erro ao buscar culturas.");
        this.dataCultures = [];
      }
    },
    async fetchApplicationMethods(pesticideId) {
      try {
        const allAplications = await ServiceCompendio.findApplicationMethods(
          pesticideId
        );

        if (allAplications?.id) {
          this.dataAplications = allAplications?.aplicacoes.map(
            (aplication) => {
              return {
                id: aplication.tiposAplicacoes.id,
                idAgrotoxico: aplication.idAgrotoxico,
                nome: aplication.tiposAplicacoes.nome,
                descricao: aplication.descricao,
                codEs: aplication.tiposAplicacoes.codEs,
                codMt: aplication.tiposAplicacoes.codMt,
                mensagemAlerta: aplication.mensagemAlerta,
              };
            }
          );
        }
      } catch (error) {
        this.$toast.error("Erro ao buscar as aplicações do agrotóxico.");
        this.dataAplications = [];
      }
    },
    async handleCultureSelection(item) {
      const selectedCultureId = item?.idCultura;

      // Na edição, o diagnóstico atual precisa permanecer selecionado.

      if (!selectedCultureId) return;

      this.selectedCultureData = item;

      this.currentProduct.infortecnicaReceita.cultura = item;
      this.currentProduct.infortecnicaReceita.nomeCultura = item.nomeCultura;
      this.currentProduct.infortecnicaReceita.maxAplicacoesBula =
        item.maxAplicacoesBula;

      await this.fetchDiagnoses(this.idPesticide, selectedCultureId);
    },
    async fetchDiagnoses(pesticideId, cultureId) {
      try {
        const diagnoses = await ServiceCompendio.findDiagnosysIdCulture(
          pesticideId,
          cultureId,
          this.ufCustomerProperty
        );

        if (Array.isArray(diagnoses)) {
          this.dataTargets = diagnoses.map((item) => {
            return {
              ...item,
              masterName: `${item.nomeComum} (${item.nomeCientifico})`,
            };
          });
        } else {
          this.dataTargets = [];
        }

        this.$toast.clear();
      } catch (error) {
        this.$toast.error("Erro ao buscar diagnósticos.");
        this.dataTargets = [];
      }
    },
    onDoseModeChange() {
      const { infortecnicaReceita } = this.currentProduct;
      const rangeDoseString = infortecnicaReceita.doseBula;
      const rangeString = infortecnicaReceita.volumeCaldaBula;
      if (!rangeDoseString) return;
      if (!rangeString) return;

      const partsDose = String(rangeDoseString)
        .split("-")
        .map((p) => p.trim());
      const minDose = partsDose[0];
      const maxDose = partsDose.length > 1 ? partsDose[1] : minDose;

      const parts = String(rangeString)
        .split("-")
        .map((p) => p.trim());
      const min = parts[0];
      const max = parts.length > 1 ? parts[1] : min;

      let newValueDose = rangeDoseString;
      let newValue = rangeString;

      if (infortecnicaReceita.doseSelectionMode === "minimo") {
        newValueDose = minDose;
        newValue = min;
      } else if (infortecnicaReceita.doseSelectionMode === "maximo") {
        newValueDose = maxDose;
        newValue = max;
      }

      infortecnicaReceita.doseUtilizada = newValueDose;
      infortecnicaReceita.volumeCaldaUtilizado = newValue;
      if (this.$refs.doseUtilizada) {
        this.$refs.doseUtilizada.valueInput = newValueDose;
      }
      if (this.$refs.volumeCaldaUtilizado) {
        this.$refs.volumeCaldaUtilizado.valueInput = newValue;
      }
    },

    handleDiagnosisSelection(selectedDiagnosis) {
      const selectedDiagnosisObject = selectedDiagnosis;

      if (!selectedDiagnosisObject || !this.selectedCultureData) {
        this.$toast.warning(
          "Dados incompletos. Objeto de diagnóstico não foi encontrado."
        );
        return;
      }

      this.$toast.success("Dados técnicos preenchidos automaticamente!");

      const { infortecnicaReceita } = this.currentProduct;
      const cultureData = this.selectedCultureData;

      infortecnicaReceita.doseBula = `${selectedDiagnosisObject.doseMinima} - ${selectedDiagnosisObject.doseMaxima}`;
      infortecnicaReceita.volumeCaldaBula = `${selectedDiagnosisObject.doseMinimaVolumeCalda} - ${selectedDiagnosisObject.doseMaximaVolumeCalda}`;
      infortecnicaReceita.intervaloSeguranca = cultureData.intervaloSeguranca;
      infortecnicaReceita.intervaloAplicacao =
        cultureData.intervaloEntreAplicacoes;
      if (this.$refs.intervaloAplicacao)
        this.$refs.intervaloAplicacao.valueInput =
          cultureData?.intervaloEntreAplicacoes;

      infortecnicaReceita.numAplicacoes = cultureData?.numeroAplicacao;
      if (this.$refs.numAplicacoes)
        this.$refs.numAplicacoes.valueInput = cultureData?.numeroAplicacao;

      infortecnicaReceita.formaAplicacao = selectedDiagnosis.observacao;
      this.descriptionItems.indicacao = selectedDiagnosis?.observacao
        ?.replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n");

      infortecnicaReceita.idIndicacao = selectedDiagnosisObject.idIndicacao;
      infortecnicaReceita.idProblema = selectedDiagnosisObject.idProblema;
      infortecnicaReceita.nomeProblema = selectedDiagnosisObject.nomeComum;
      infortecnicaReceita.nomeProblemaCientifico =
        selectedDiagnosisObject.nomeProblemaCientifico;

      infortecnicaReceita.doseSelectionMode = "intervalo";
      infortecnicaReceita.volumeCaldaSelectionMode = "intervalo";
      infortecnicaReceita.doseUtilizada = infortecnicaReceita.doseBula;
      infortecnicaReceita.unidadeDose = selectedDiagnosisObject.unidadeDose;
      infortecnicaReceita.unidadeVolumeCalda =
        selectedDiagnosisObject.unidadeVolumeCalda;
      infortecnicaReceita.volumeCaldaUtilizado =
        infortecnicaReceita.volumeCaldaBula;

      this.descriptionItems.culture = cultureData?.descricaoAplicacao
        ?.replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n");

      this.selectedDiagnosticData = selectedDiagnosis;

      this.onDoseModeChange();
    },
    clearDependentData() {
      this.dataCultures = [];
      this.dataTargets = [];
      this.selectedCultureData = null;
      this.listEmbs = [];
      this.dataAplications = [];
      this.currentProductStock = null;
    },

    openModalDeleteProduct(product) {
      this.idToDeleteItem = product.id;

      this.openModals("modal-confirm-product");
    },

    async loadPrescriptionForEdit(id) {
      try {
        this.$toast.info("Carregando dados da receita...");
        const data = await serviceSale.getAllBillsById(id);
        this.sale = data;
        await this.getApplicatorsForSelectBox(data.idAplicador);
        this.$toast.success("Receita carregada para edição.");
      } catch (error) {
        this.$toast.error("Não foi possível carregar a receita.");
        this.$router.push({ name: "lista-de-receitas" });
      }
    },
    async handleSubmit() {
      if (this.isSaveOrFinishLoading) return;

      this.isLoadingToSavePrescription = true;

      try {
        if (this.isEditing) {
          await this.updatePrescription({ showToast: true, showModal: false });
        } else {
          await this.createPrescription({
            showToast: true,
            showModal: false,
          });
        }

        if (
          this.typeComponent === "Receita Pedido" ||
          this.typeComponent === "Receita"
        ) {
          this.showAlertLimitPrescription();
        }
      } finally {
        this.isLoadingToSavePrescription = false;
      }
    },
    async createPrescription(options = { showModal: true, showToast: true }) {
      if (typeof options === "boolean") {
        options = { showModal: options, showToast: true };
      }

      const { showModal = true, showToast = true } = options;

      try {
        if (this.sale.id) return;

        const sale = this.sale;
        if (this.inspectionOrigin) {
          await this.getAllResponsibles();
        }
        if (this.sale !== sale) return;

        const payload = {
          sale: this.sale,
          bills: this.sale.bills,
        };

        const response = await serviceSale.createSaleWithoutProducts(payload);
        if (this.sale !== sale) return;
        this.sale.id = response.id;
        if (this.inspectionOrigin) {
          if (!(await this.completeInspectionPrescription())) return;
        }

        if (showToast) {
          const message =
            this.typeComponent === "Receita"
              ? "Receita emitida com sucesso!"
              : this.typeComponent === "Receita Pedido"
              ? "Pedido completo salvo com sucesso!"
              : "Pedido simples salvo com sucesso!";

          this.$toast.success(message);
        }

        if (showModal) {
          this.handleOpenModals();
        }

        return response;
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;

        this.$toast.error(message || "Erro ao emitir a receita.");

        return;
      } finally {
        this.reusePrescription = false;
      }
    },
    async updatePrescription(options = { showModal: false, showToast: true }) {
      if (typeof options === "boolean") {
        options = { showModal: false, showToast: options };
      }

      const { showModal = false, showToast = true } = options;

      try {
        const payload = {
          sale: this.sale,
          bills: this.sale.bills,
        };

        await serviceSale.updateSaleWithoutProducts(payload);
        if (this.sale !== payload.sale) return;

        if (this.inspectionOrigin) {
          if (!(await this.completeInspectionPrescription())) return;
        }

        if (showToast) {
          const message =
            this.typeComponent === "Receita"
              ? "Receita atualizada com sucesso!"
              : this.typeComponent === "Receita Pedido"
              ? "Pedido completo atualizado com sucesso!"
              : "Pedido simples atualizado com sucesso!";

          this.$toast.success(message);
        }

        if (showModal) {
          this.handleOpenModals();
        }
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;

        this.$toast.error(message || "Erro ao atualizar a receita.");

        return;
      }
    },
    async finishAndUpdatePrescription() {
      if (this.isSaveOrFinishLoading) return;

      this.isLoadingToFinishPrescription = true;

      try {
        this.sale.status = "Finalizado(a)";
        await serviceSale.updateSaleWithoutProducts({ sale: this.sale });

        this.$toast.success("Receita finalizada com sucesso!");

        this.handleOpenModals(true);

        this.registerModalCloseListener();
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;

        this.$toast.error(message || "Erro ao finalizar a receita.");
      } finally {
        this.isLoadingToFinishPrescription = false;
      }
    },
    async addProduct() {
      const restriction = prescriptionProductError(this.dataConfig, this.tableProducts, this.currentProduct);
      if (restriction) return this.$toast.open({ message: restriction, type: "info" });
      try {
        this.isLoadingToAddProd = true;
        this.closeModals("alert-modal");

        if (!this.sale.id) {
          await this.createPrescription({ showModal: false, showToast: false });
          if (!this.sale.id) return;
        }

        this.currentProduct.id
          ? await this.updateProductOfSale()
          : await this.saveProductOfSale();
      } finally {
        this.isLoadingToAddProd = false;
      }
    },
    async saveProductOfSale() {
      try {
        this.currentProduct.idVenda = this.sale.id;
        await serviceProductSale.save(this.currentProduct);
        await this.handleFindProductsAndCalculateTotals();

        this.clearProductForm();

        return this.$toast.open({
          message: "Produto adicionado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : error?.response?.data?.message ||
              "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      }
    },

    async updateProductOfSale() {
      try {
        this.currentProduct.idVenda = this.sale.id;
        await serviceProductSale.update(
          this.currentProduct.id,
          this.currentProduct
        );
        await this.handleFindProductsAndCalculateTotals();

        this.clearProductForm();

        return this.$toast.open({
          message: "Produto atualizado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: Object.keys(error?.response?.data?.erros)?.length
            ? error?.response?.data?.erros
            : error?.response?.data?.message ||
              "Ocorreu um problema ao salvar o produto",
          type: "info",
        });
      }
    },

    async findTableProductsOfSale() {
      const result = await serviceProductSale.findByIdSale(this.sale.id);

      this.tableProducts = result || [];
    },
    async editProductsOfSale(prod) {
      try {
        const newProd = removeReference(prod);
        this.currentProduct = ensureItemTax(newProd, this.allRefsFiscais);

        this.handleRefsProductForm(false);
        this.handleCalculateTotal();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao editar o produto",
          type: "info",
        });
      }
    },
    async removeItens() {
      try {
        await serviceProductSale.delete(this.idToDeleteItem);
        this.handleFindProductsAndCalculateTotals();

        return this.$toast.open({
          message: "Produto removido",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.message}` ||
            "Ocorreu um erro ao remover o produto!",
          type: "info",
        });
      }
    },
    async getProductById(idProduct) {
      const data = await serviceProducts.getProductById(idProduct);
      return data;
    },
    handleClearInfortecnicaReceitaWithoutAgrotoxico() {
      this.isCultureDiagsClared = true;

      const { idAgrotoxico } = this.currentProduct.infortecnicaReceita;
      this.currentProduct.infortecnicaReceita = {
        ...createEmptyProduct().infortecnicaReceita,
        idAgrotoxico,
      };

      Object.keys(this.currentProduct.infortecnicaReceita).forEach((key) => {
        if (this.$refs[key] && "valueInput" in this.$refs[key])
          this.$refs[key].valueInput = "";
        else if (this.$refs[key] && "valueItems" in this.$refs[key])
          this.$refs[key].valueItems = "";
      });

      this.toggleClearSelect = !this.toggleClearSelect;
      this.clearDependentData();
    },
    async handleResetCultureDiag() {
      this.isCultureDiagsClared = true;

      this.currentProduct.infortecnicaReceita.idCultura = "";
      this.currentProduct.infortecnicaReceita.idIndicacao = "";

      this.$refs.idCultura.valueItems = "";
      this.$refs.idIndicacao.valueItems = "";

      this.dataTargets = [];

      await this.fetchCultures(
        this.currentProduct.infortecnicaReceita.idAgrotoxico
      );
    },
    async alterDiscountIsChecked() {
      this.TOGGLE_DISCOUNT(!this.discountIsChecked);

      if (this.sale.tipo === "Receita Pedido") {
        if (this.discountIsChecked) {
          this.sale.tipoDesconto = "Porcentagem";
        } else {
          this.sale.tipoDesconto = "Valor Monetário";
        }

        if (this.sale.id) await this.updatePrescription(false);

        this.handleCalculateObjectTotal();
        this.handleCalculateTotal();
      }
    },
    async generateCompletedSale() {
      this.SET_ID_TRANSFORM_COMPLETED_SALE(this.sale.id);

      this.sale.tipo = "Receita Pedido";
      await serviceSale.updateTypeOrder(this.sale.id, this.sale.tipo);

      this.$router.push("/vendas");
    },
    handleReusePrescription() {
      const { idResponsavelTecnico, receita, art, complementoReceita } =
        this.sale;

      this.clearRecipeForm(false);

      this.sale.idResponsavelTecnico = idResponsavelTecnico;
      this.sale.receita = receita;
      this.sale.art = art;
      this.sale.complementoReceita = complementoReceita;

      this.$refs.idResponsavelTecnico.valueItems = idResponsavelTecnico;
      this.$refs.receita.valueInput = receita;
      this.$refs.art.valueInput = art;
      this.$refs.complementoReceita.valueInput = complementoReceita;
      this.tableProducts = [];

      this.reusePrescription = true;

      this.$toast.open({
        message: `Receita Nº ${this.sale.receita} pronta para uso na nova receita.`,
        type: "success",
      });
    },
    handleAddItemsAndVerifyAlerts() {
      this.isCultureDiagsClared = false;

      const restriction = prescriptionProductError(this.dataConfig, this.tableProducts, this.currentProduct);
      if (restriction) return this.$toast.open({ message: restriction, type: "info" });

      if (!this.sale.idPropriedade) {
        return this.$toast.open({
          message:
            "(Cliente) e (Propriedade) devem ser selecionados para prosseguir",
          type: "info",
        });
      }

      if (!this.validateRequiredAgrotoxicoData()) return;

      if (
        this.getPesticideRestriction ||
        this.getCultureRestriction ||
        this.getDiagnosticRestriction
      ) {
        return this.openModals("alert-modal");
      }

      this.addProduct();
    },
    validateRequiredAgrotoxicoData() {
      const infortecnicaReceita =
        this.currentProduct.infortecnicaReceita || {};

      const requiredFields = [
        {
          label: "Agrotóxico",
          isValid:
            infortecnicaReceita.idAgrotoxico &&
            infortecnicaReceita.agrotoxico &&
            infortecnicaReceita.registroAgrotox,
        },
        {
          label: "Diagnóstico",
          isValid: infortecnicaReceita.idProblema,
        },
        {
          label: "Embalagem",
          isValid: infortecnicaReceita.embalagem,
        },
        {
          label: "Modalidade de aplicação",
          isValid:
            infortecnicaReceita.idTipoAplicacao &&
            infortecnicaReceita.nomeTipoAplicacao,
        },
      ];

      const missingFields = requiredFields
        .filter(({ isValid }) => !isValid)
        .map(({ label }) => label);

      if (!missingFields.length) return true;

      this.$toast.open({
        message: `Preencha os campos obrigatórios: ${missingFields.join(
          ", "
        )}.`,
        type: "info",
      });

      return false;
    },
    handleAssingUfProperty(item) {
      this.ufCustomerProperty = item?.uf;
    },
    removeProduct(index) {
      this.sale.products.splice(index, 1);
      this.$toast.info("Agrotóxico removido.");
    },
    showProductDetails(product) {
      this.selectedProductDetails = product;
      this.$bvModal.show("modal-details-product");
    },
    clearProductForm() {
      this.currentProduct = createEmptyProduct();
      this.toggleClearSelect = !this.toggleClearSelect;
      this.handleRefsProductForm();

      this.aplicationRestriction = null;

      this.infoProd = {};
    },
    async printReportSelect(toSign = false, openedWindow = null) {
      if (!this.sale.id) return;

      if (
        toSign &&
        !this.sale.signedDate &&
        !this.canUseDigitalSignature
      ) {
        return this.$toast.info(
          "Este usuário não tem permissão para assinatura digital"
        );
      }

      const result = await print("receiptStandard", this.sale.id, toSign);

      if ("html" in result) {
        if (openedWindow && !openedWindow.closed) {
          openedWindow.document.open();
          openedWindow.document.write(result.html);
          openedWindow.document.close();
        } else {
          this.SET_HTML_TO_PRINT(result.html);
        }
      } else if ("url" in result) {
        if (openedWindow && !openedWindow.closed) {
          openedWindow.location.href = result.url;
        } else {
          window.open(result.url, "_blank");
        }
      }
    },

    async handleSignPrescription() {
      if (!this.canUseDigitalSignature) return;

      const openedWindow = window.open("", "_blank");

      if (openedWindow && !openedWindow.closed) {
        openedWindow.document.open();
        openedWindow.document.write(
          "<html><head><title>Assinando receita...</title></head><body><p style='font-family: Arial, sans-serif; padding: 16px;'>Gerando receita assinada...</p></body></html>"
        );
        openedWindow.document.close();
      }

      try {
        await this.printReportSelect(true, openedWindow);
      } catch (error) {
        if (openedWindow && !openedWindow.closed) {
          openedWindow.close();
        }

        this.$toast.open({
          message: "Erro ao assinar receita",
          type: "error",
        });
      }
    },

    openModalCancelSale() {
      this.$bvModal.show("modal-confirm-cancel-prescription");
    },

    async cancelSale() {
      try {
        this.sale.status = "Cancelado";

        await serviceSale.cancel(this.sale.id, this.sale.status);

        if (this.$refs?.additionalInformationRef?.$refs?.generateBillsRef) {
          await this.$refs.additionalInformationRef.$refs.generateBillsRef.handleFindBills();
        }

        await this.handleFindProductsAndCalculateTotals();

        this.$toast.open({
          message: "Receita cancelada com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        this.$toast.open({
          message: error?.response?.data?.message || "Erro ao cancelar receita",
          type: "error",
        });
      }
    },

    async reOpenSale() {
      try {
        await serviceSale.reOpen(this.sale.id);
        this.sale.status = "Rascunho";

        this.$toast.open({
          message: `${this.getComponenteTitle} reaberta para utilização!`,
          type: "success",
        });
      } catch (error) {
        toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async ncmCombobox() {
      try {
        this.listNcms = await serviceNcms.fillComobobox();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar os ncms do produto",
          type: "info",
        });
      }
    },

    printReportVendaOrcamento() {
      if (!this.sale.id) return;

      print("reportVendaOrcamento", this.sale.id);
    },
    clearRecipeForm(showToast = true) {
      this.sale = createEmptySale();
      this.inspectionOrigin = null;
      this.pendingInspectionProducts = [];
      this.isImportingInspectionProducts = false;
      this.clearProductForm();

      Object.keys(this.sale).forEach((key) => {
        if (this.$refs[key] && "valueInput" in this.$refs[key])
          this.$refs[key].valueInput = "";
        else if (this.$refs[key] && "valueItems" in this.$refs[key])
          this.$refs[key].valueItems = "";
      });

      if (showToast)
        this.$toast.info("Formulário limpo. Pronto para uma nova receita.");
    },
    clearInputs() {
      this.dataPrescription.id = "";
      this.dataPrescription.data = "";
      this.dataPrescription.numeroNfe = "";
      this.dataPrescription.serieNfe = "";
      this.dataPrescription.cfop = "";
      this.newOrder = !this.newOrder;
      this.toggleClearSelect = !this.toggleClearSelect;
    },
    handleRefsProductForm(isClear = true) {
      Object.keys(this.currentProduct.infortecnicaReceita).forEach((key) => {
        const currentValue = isClear
          ? ""
          : this.currentProduct.infortecnicaReceita[key];

        if (this.$refs[key] && "valueInput" in this.$refs[key])
          this.$refs[key].valueInput = currentValue;
        else if (this.$refs[key] && "valueItems" in this.$refs[key])
          this.$refs[key].valueItems = currentValue;
      });

      Object.keys(this.currentProduct).forEach((key) => {
        const currentValue = isClear ? "" : this.currentProduct[key];

        const newKey = key === "desconto" ? "discountItem" : key;
        if (this.$refs[newKey] && "valueInput" in this.$refs[newKey])
          this.$refs[newKey].valueInput = currentValue;
        else if (this.$refs[key] && "valueItems" in this.$refs[key])
          this.$refs[key].valueItems = currentValue;
      });
    },
    handleCreatedNewProduct() {
      this.createdNewProducts = !this.createdNewProducts;
    },
    handleModalCreateProduct(nameModal, idProduct) {
      this.idProductFromSearch = idProduct;
      this.openModals(nameModal);
    },

    handleOpenModalsMessage(type) {
      this.defaultMessage = type;
      this.openModals("modalMessages");
    },

    handleGenerateCompletedOrder() {
      const isMobile = window.innerWidth <= 764;

      if (isMobile) {
        this.openModals("modal-mobile-unavailable");
      } else {
        this.openModals("transform-in-completed-sale");
      }
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleOpenModals(forceOpen = false) {
      if (
        this.sale.tipo === "Pedido" &&
        (forceOpen || this.sale.status !== "Finalizado(a)")
      ) {
        this.openModals("modal-actions-order");
      } else if (
        this.sale.tipo === "Receita" &&
        (forceOpen || this.sale.status !== "Finalizado(a)")
      ) {
        this.openModals("modal-actions-prescription");
      } else if (this.sale.tipo === "Receita Pedido") {
        this.openModals("modal-actions-prescription");
      }
    },

    closeModals(idModal) {
      this.$bvModal.hide(idModal);
    },

    registerModalCloseListener() {
      const handler = () => {
        this.$root.$off("bv::modal::hidden", handler);
        this.unlockBodyScroll();
        this.$emit("closeModal");
      };

      this.$root.$on("bv::modal::hidden", handler);
    },

    handleOpenModalPesticideAlert() {
      document.activeElement.blur();

      if (this.currentProduct.mensagemAlerta) {
        this.openModals("alert-modal-select-perticide");
      }
    },

    calcArea() {
      if (isNaN(+this.currentProduct.infortecnicaReceita.numAplicacoes)) {
        this.$refs.numAplicacoes.$el.querySelector("input").focus();

        return this.$toast.open({
          message: "(N° de Aplicações) deve ser um número inteiro",
          type: "info",
        });
      } else if (
        this.currentProduct.infortecnicaReceita.doseSelectionMode ===
        "intervalo"
      ) {
        return this.$toast.open({
          message:
            "(Dose / Volume de calda) deve ser diferente de (Intervalo) para que a calculadora funcione corretamente!",
          type: "info",
        });
      }

      const medidaUnidadeDose = this.getMedidaUnidadeDose();
      if (!medidaUnidadeDose)
        return this.$toast.open({
          message:
            "Não é possível realizar o cálculo para este agrotóxico com essa unidade de dose",
          type: "info",
        });

      const isCalculate = this.verifyExecCalcQntProd();
      if (!isCalculate) return;

      const selectedPackaging = this.listEmbs.find(
        (item) =>
          item.descricao ===
          this.currentProduct.infortecnicaReceita.embalagem
      );
      const quantidade = calculateProductQuantity({
        packageQuantity: this.currentProduct.quantidade,
        packageCapacity: selectedPackaging?.capacidade,
        packageUnit: selectedPackaging?.unidade,
        doseUnit: this.currentProduct.infortecnicaReceita.unidadeDose,
      });

      if (quantidade === null)
        return this.$toast.open({
          message:
            "Não foi possível identificar a quantidade total do produto para o cálculo.",
          type: "info",
        });

      const doseUtilizada = Number(
        this.currentProduct.infortecnicaReceita.doseUtilizada
      );
      const numAplicacoes = Number(
        this.currentProduct.infortecnicaReceita.numAplicacoes
      );
      const volumeCaldaUtilizado = Number(
        this.currentProduct.infortecnicaReceita.volumeCaldaUtilizado
      );

      let calc = 0;
      if (medidaUnidadeDose === "ha") {
        calc = quantidade / doseUtilizada / numAplicacoes;
      } else if (medidaUnidadeDose === "100 L") {
        calc =
          (quantidade *
            (1 / doseUtilizada) *
            100 *
            (1 / volumeCaldaUtilizado)) /
          numAplicacoes;
      }

      this.currentProduct.infortecnicaReceita.areatratar = Number(
        calc.toFixed(3)
      );

      this.$refs.areatratar.valueInput = Number(calc.toFixed(3));
    },

    calcQuantProd() {
      if (isNaN(+this.currentProduct.infortecnicaReceita.numAplicacoes)) {
        this.$refs.numAplicacoes.$el.querySelector("input").focus();

        return this.$toast.open({
          message: "(N° de Aplicações) deve ser um número inteiro",
          type: "info",
        });
      } else if (
        this.currentProduct.infortecnicaReceita.doseSelectionMode ===
        "intervalo"
      ) {
        return this.$toast.open({
          message:
            "(Dose / Volume de calda) deve ser diferente de (Intervalo) para que a calculadora funcione corretamente!",
          type: "info",
        });
      }

      const medidaUnidadeDose = this.getMedidaUnidadeDose();
      if (!medidaUnidadeDose)
        return this.$toast.open({
          message:
            "Não é possível realizar o cálculo para este agrotóxico com essa unidade de dose",
          type: "info",
        });

      const isCalculate = this.verifyExecCalcQntProd();
      if (!isCalculate) return;

      if (medidaUnidadeDose === "ha") {
        this.currentProduct.quantidade =
          Number(this.currentProduct.infortecnicaReceita.doseUtilizada) *
          Number(this.currentProduct.infortecnicaReceita.areatratar) *
          Number(this.currentProduct.infortecnicaReceita.numAplicacoes);
      } else if (medidaUnidadeDose === "100 L") {
        this.currentProduct.quantidade =
          this.currentProduct.infortecnicaReceita.doseUtilizada *
          this.currentProduct.infortecnicaReceita.areatratar *
          0.01 *
          this.currentProduct.infortecnicaReceita.volumeCaldaUtilizado *
          this.currentProduct.infortecnicaReceita.numAplicacoes;
      }

      this.$refs.quantidade.valueInput = this.currentProduct.quantidade;

      this.handleCalculateTotal();
    },

    async getAllPayment() {
      const result = await servicePaymentForm.getAllPayment();
      this.allPaymentsTypes = result.sort((a, b) => a.cod - b.cod);
    },
    async getAllPropertys(idCliente) {
      const result = await serviceCustomerProperty.fillComobobox(idCliente);
      this.dataProperties = result;
    },
    async getAllResponsibles() {
      const selectedId =
        this.sale.idResponsavelTecnico ||
        this.dataSearchFromSale.idResponsavelTecnico;
      const result = await serviceResponsible.getResponsibleForSelectBox(
        selectedId
      );
      this.dataTechnicalManagers = result;

      if (!this.sale.id && !selectedId && result.length) {
        const defaultResponsible =
          result.find(
            (responsible) =>
              responsible.nome?.localeCompare(
                "RESPONSÁVEL TÉCNICO TESTE",
                "pt-BR",
                { sensitivity: "base" }
              ) === 0
          ) || result[0];
        this.sale.idResponsavelTecnico = defaultResponsible.id;

        await this.$nextTick();
        if (this.$refs.idResponsavelTecnico) {
          this.$refs.idResponsavelTecnico.valueItems = defaultResponsible.id;
        }
        this.handleDataTech(defaultResponsible.id);
      }

      if (
        this.inspectionOrigin &&
        !this.sale.id &&
        selectedId &&
        result.some((manager) => manager.id === selectedId)
      ) {
        await this.$nextTick();
        this.handleDataTech(selectedId);
      }
    },
    async getAllMessages() {
      const result = await serviceMessages.fillComobobox();

      const groupedMessages = result?.reduce(
        (prev, message) => {
          if (message.tipo === "geral") prev.geral = [message, ...prev.geral];
          else prev.mip = [message, ...prev.mip];

          return prev;
        },
        { geral: [], mip: [] }
      );

      this.messages.geral = groupedMessages?.geral || [];
      this.messages.mip = groupedMessages?.mip || [];

      const isNewPrescription =
        this.verifyIfContainsPrescription &&
        !this.sale.id &&
        !this.dataSearchFromSale?.id;

      if (
        isNewPrescription &&
        !this.sale.observacoesReceita &&
        this.messages.geral.length
      ) {
        const [defaultMessage] = this.messages.geral;
        this.dataPrescription.observacao = defaultMessage.id;
        this.handleAssingMessage(defaultMessage, "observacao");
      }

      if (isNewPrescription && !this.sale.mip && this.messages.mip.length) {
        const defaultMip =
          this.messages.mip.find(
            (message) =>
              message.titulo?.localeCompare("MIP PADRÃO", "pt-BR", {
                sensitivity: "base",
              }) === 0
          ) || this.messages.mip[0];
        this.dataPrescription.obsmip = defaultMip.id;
        this.handleAssingMessage(defaultMip, "mip");
      }
    },
    handleAssingMessage(message, type = "mip") {
      if (type === "mip") this.sale.mip = message.texto;
      else this.sale.observacoesReceita = message.texto;
    },
    async handleAssingEmb(emb) {
      this.currentProductStock = null;
      this.currentProduct.infortecnicaReceita.embalagem =
        this.listEmbs.find((embItem) => embItem.descricao === emb)?.descricao ||
        null;

      if (
        this.currentProduct.infortecnicaReceita.embalagem &&
        this.currentProduct.infortecnicaReceita.idAgrotoxico
      )
        await this.findLotes(
          this.currentProduct.infortecnicaReceita.idAgrotoxico,
          this.currentProduct.infortecnicaReceita.embalagem,
          this.currentProduct.infortecnicaReceita.registroAgrotox
        );
    },
    handleChangeAplication(aplication) {
      this.descriptionItems.aplicationMethod = aplication?.descricao
        ?.replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n");

      const { aplicationMethod, culture, indicacao, pesticide } =
        this.descriptionItems;

      this.currentProduct.infortecnicaReceita.modoaplicacao =
        pesticide + aplicationMethod + culture + indicacao;

      this.currentProduct.infortecnicaReceita.nomeTipoAplicacao =
        aplication?.nome;

      this.currentProduct.infortecnicaReceita.tipoAplicacaoCodEs =
        aplication.codEs;
      this.currentProduct.infortecnicaReceita.tipoAplicacaoCodMt =
        aplication.codMt;

      this.descriptionItems = {
        aplicationMethod: "",
        pesticide: "",
        culture: "",
        indicacao: "",
      };

      this.aplicationRestriction = {
        nome: aplication.nome,
        mensagemAlerta: aplication.mensagemAlerta,
      };

      if (this.aplicationRestriction.mensagemAlerta) {
        this.openModals("alert-modal-select-aplication");
      }
    },
    handleSaleProductsIfAny() {
      if (!this.dataSearchFromSale?.products?.length) {
        Reflect.deleteProperty(this.dataSearchFromSale, "products");
      }
    },
    removePendingInspectionProduct(product) {
      if (this.isImportingInspectionProducts) return;
      const index = this.pendingInspectionProducts.findIndex(
        (item) => item.inspectionRecommendationId === product.inspectionRecommendationId
      );
      if (index >= 0) this.pendingInspectionProducts.splice(index, 1);
    },
    async importPendingInspectionProducts() {
      if (this.isImportingInspectionProducts || !this.sale.id) return false;
      if (!this.pendingInspectionProducts.length) return true;

      const sale = this.sale;
      const saleId = sale.id;
      const queue = this.pendingInspectionProducts;
      this.isImportingInspectionProducts = true;
      try {
        const productsToImport = [...queue];
        for (const product of productsToImport) {
          if (this.sale !== sale || this.pendingInspectionProducts !== queue) return false;
          await serviceProductSale.save({
            ...product,
            valorTotal: Number(product.quantidade) * Number(product.valorUnitario || 0),
            idVenda: saleId,
          });
          if (this.sale !== sale || this.pendingInspectionProducts !== queue) return false;
          const importedIndex = this.pendingInspectionProducts.findIndex(
            (item) =>
              item.inspectionRecommendationId === product.inspectionRecommendationId
          );
          if (importedIndex >= 0) this.pendingInspectionProducts.splice(importedIndex, 1);
        }
        await this.handleFindProductsAndCalculateTotals();
        this.$toast.success("Produtos da inspeção adicionados à receita.");
        return true;
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.message ||
            "A receita foi criada, mas um produto da inspeção não pôde ser adicionado."
        );
        return false;
      } finally {
        if (this.pendingInspectionProducts === queue) {
          this.isImportingInspectionProducts = false;
        }
      }
    },
    async completeInspectionPrescription() {
      const sale = this.sale;
      const origin = this.inspectionOrigin;
      if (!(await this.importPendingInspectionProducts())) return false;
      if (this.sale !== sale || this.inspectionOrigin !== origin) return false;
      return await this.linkInspectionRecipe();
    },
    async linkInspectionRecipe() {
      if (!this.sale.id || !this.inspectionOrigin?.inspectionId) return false;
      const sale = this.sale;
      const origin = this.inspectionOrigin;
      try {
        await serviceInspection.linkRecipe(this.inspectionOrigin.inspectionId, {
          recipeId: this.sale.id,
          diagnosisIds: this.inspectionOrigin.diagnosisIds,
          cultureId: this.inspectionOrigin.cultureId,
        });
        return this.sale === sale && this.inspectionOrigin === origin;
      } catch (error) {
        this.$toast.warning(
          "A receita foi criada, mas o vínculo com a inspeção não pôde ser atualizado."
        );
        return false;
      }
    },
    handleAssingEpi(classificacao) {
      this.dataPesticides.epi =
        "RESPIRADORES SEMIFACIAIS OU FACIAIS COM FILTROS P2 OU P3. ÓCULOS DE SEGURANÇA OU VISEIRA FACIAL. MACACÃO DE ALGODÃO HIDRO-REPELENTE E IMPERMEÁVEL. AVENTAL DE BAGUM E/OU TECIDO EMBORRACHADO ALUMINIZADO. BOTA IMPERMEÁVEL DE CANO ALTO (PVC). AO SURGIMENTO DE QUALQUER DÚVIDA, LEIA AS RECOMENDAÇÕES DO RÓTULO E BULA.";

      if (classificacao == "I" || classificacao == "II") {
        this.dataPesticides.epi =
          "Luvas impermeáveis de borracha nitrílica ou neoprene. Respiradores semifaciais ou faciais com filtros P2 ou P3. Óculos de segurança ou viseira facial. Macacão de algodão hidro-repelente com mangas compridas passando por cima do punho das luvas e as pernas da calças por cima das botas. Boné árabe hidro-repelente de algodão. Avental de bagum e/ou tecido emborrachado aluminizado. Bota impermeável de cano alto (PVC). Ao surgimento de qualquer dúvida, leia as recomendações do rótulo e bula.".toUpperCase();
      } else if (classificacao == "III" || classificacao == "IV") {
        this.dataPesticides.epi =
          "Luvas impermeáveis de borracha nitrílica ou neoprene. Respiradores semifaciais ou faciais com filtros P2 ou P3. Óculos de segurança ou viseira facial. Macacão de algodão hidro-repelente e impermeável. Boné árabe hidro-repelente de algodão. Bota impermeável de cano alto (PVC). Ao surgimento de qualquer dúvida, leia as recomendações do rótulo e bula.".toUpperCase();
      }
    },
    assignDataSearchFromSale() {
      const saleData = { ...this.dataSearchFromSale };
      const inspectionContext = extractInspectionPrescriptionOrigin(
        saleData,
        this.$route?.query?.origem
      );
      this.pendingInspectionProducts = inspectionContext.pendingProducts;
      this.inspectionOrigin = inspectionContext.origin;
      removeInspectionPrescriptionTransientFields(saleData);
      Object.assign(this.sale, saleData);
      this.tableProducts = saleData.products || [];

      Reflect.deleteProperty(this.sale, "products");

      this.originalResponsible.id = this.sale.idResponsavelTecnico;
      this.originalResponsible.receita = this.sale.receita;
      this.originalResponsible.serieSC = this.sale.serieSC;

      this.getAllResponsibles();

      this.TOGGLE_DISCOUNT(
        this.dataSearchFromSale.tipoDesconto === "Porcentagem" ? true : false
      );

      this.handleCalculateObjectTotal();

      this.$refs.funcionario.valueItems = this.dataSearchFromSale.idFuncionario;
      this.getApplicatorsForSelectBox(this.sale.idAplicador);

      if (this.verifyIfContainsPrescription) {
        this.$refs.idPropriedade.valueItems =
          this.dataSearchFromSale.idPropriedade;
        this.$refs.idResponsavelTecnico.valueItems =
          this.dataSearchFromSale.idResponsavelTecnico;
        this.$refs.receita.valueInput = this.dataSearchFromSale.numero;
        this.$refs.art.valueInput = this.dataSearchFromSale.art;
        this.$refs.complementoReceita.valueInput =
          this.dataSearchFromSale.complementoReceita;
      }

      Object.keys(this.sale).forEach((key) => {
        if (this.$refs[key] && "valueInput" in this.$refs[key]) {
          this.$refs[key].valueInput = this.sale[key];
        } else if (this.$refs[key] && "valueItems" in this.$refs[key])
          this.$refs[key].valueItems = this.sale[key];
      });
    },
    handleCalculateObjectTotal() {
      const totals = this.tableProducts.reduce(
        (prev, prod) => {
          const type = prod.typeProduct;

          let calculatedDiscount = 0;
          if (this.sale.tipoDesconto === "Porcentagem") {
            calculatedDiscount = prod.valorTotal * (prod.desconto / 100);
          } else {
            calculatedDiscount = prod.desconto;
          }

          const valorLiquido = prod.valorTotal - calculatedDiscount;

          prev.totalOfItens += prod.valorTotal;
          prev.totalDiscount += calculatedDiscount;
          prev.totalSale += valorLiquido;

          if (!prev.byType[type]) {
            prev.byType[type] = {
              amountItems: 0,
              totalValueItems: 0,
              totalDiscountItems: 0,
              subtotalItems: 0,
            };
          }

          prev.byType[type].amountItems += prod.quantidade;
          prev.byType[type].totalValueItems += valorLiquido;
          prev.byType[type].totalDiscountItems += calculatedDiscount;
          prev.byType[type].subtotalItems += prod.valorTotal;

          return prev;
        },
        {
          totalOfItens: 0,
          totalDiscount: 0,
          totalSale: 0,
          byType: {
            amountItems: 0,
            totalValueItems: 0,
            totalDiscountItems: 0,
            subtotalItems: 0,
          },
        }
      );

      this.objectTotals = {
        totalOfSale: +totals.totalSale.toFixed(2),
        totalOfItens: +totals.totalOfItens.toFixed(2),
        totalOfDiscount: +totals.totalDiscount.toFixed(2),
        byType: {
          agrotoxicos: totals.byType.agrotoxicos
            ? {
                amountItems: totals.byType.agrotoxicos.amountItems,
                totalValueItems:
                  +totals.byType.agrotoxicos.totalValueItems.toFixed(2),
                totalDiscountItems:
                  +totals.byType.agrotoxicos.totalDiscountItems.toFixed(2),
                subtotalItems:
                  +totals.byType.agrotoxicos.subtotalItems.toFixed(2),
              }
            : {
                amountItems: 0,
                totalValueItems: 0,
                totalDiscountItems: 0,
                subtotalItems: 0,
              },
          simples: totals.byType.simples
            ? {
                amountItems: totals.byType.simples.amountItems,
                totalValueItems:
                  +totals.byType.simples.totalValueItems.toFixed(2),
                totalDiscountItems:
                  +totals.byType.simples.totalDiscountItems.toFixed(2),
                subtotalItems: +totals.byType.simples.subtotalItems.toFixed(2),
              }
            : {
                amountItems: 0,
                totalValueItems: 0,
                totalDiscountItems: 0,
                subtotalItems: 0,
              },
        },
      };
    },

    async findAllRefs() {
      try {
        const result = await serviceTax.findAllRefs();

        this.allRefsFiscais = result.data.map((e) => {
          return {
            id: e.id,
            descricao: `${e.ref} - ${e.descricao}`,
            ref: e.ref,
            refObject: e.refObject,
            imposto_manual: e.imposto_manual,
            flags: e.flags,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async handleFindProductsAndCalculateTotals() {
      await this.findTableProductsOfSale();

      this.handleCalculateObjectTotal();
    },
    async handleUpdateSale() {
      if (this.discountIsChecked) {
        this.sale.tipoDesconto = "Porcentagem";
      } else {
        this.sale.tipoDesconto = "Valor Monetário";
      }

      if (this.sale.id) await this.updatePrescription(false);
    },
    async handleFindProducts() {
      if (this.discountIsChecked) {
        this.sale.tipoDesconto = "Porcentagem";
      } else {
        this.sale.tipoDesconto = "Valor Monetário";
      }

      await this.handleFindProductsAndCalculateTotals();
    },
    handleSaleValues() {
      this.handleSaleProductsIfAny();
      this.assignDataSearchFromSale();
    },
    async handleTranformToNfeAndCloseModal() {
      this.closeModals("modal-actions-order");
      this.transformToNfe();
    },

    async transformToNfe() {
      try {
        const dataNFe = await serviceSale.transformInNotaToSend(this.sale.id);
        this.SET_DATA_NFE(dataNFe);

        this.$toast.open({
          message: "Nota fiscal gerada!",
          type: "success",
        });

        this.$router.push({
          path: `/fiscal`,
        });
      } catch (error) {
        return toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async sendCoupon(isLeaveClient) {
      try {
        const data = await serviceNotaFiscal.sendCoupon(
          this.sale.id,
          isLeaveClient
        );
        const danfe = data.dataWebMania.danfe;
        this.visualizarNfe(danfe);
        this.$bvModal.hide("check-customer");

        return this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      }
    },

    async showAlertLimitPrescription() {
      if (Object.keys(this.dataConfig).length) {
        const responsible = await serviceResponsible.findById(
          this.sale.idResponsavelTecnico
        );

        if (
          responsible.quantidadeReceita <=
          Number(this.dataConfig.receita.alertaMinimoReceita)
        ) {
          this.$toast.open({
            message: `Suas receitas estão prestes a acabar, restão apenas ${responsible.quantidadeReceita}`,
            type: "info",
            duration: 0,
          });
        }
      }
    },
    getMedidaUnidadeDose() {
      try {
        const items =
          this.currentProduct.infortecnicaReceita.unidadeDose.split("/");

        let medidaUnidadeDose = items[1].substring(0, 2);

        if (medidaUnidadeDose != "ha")
          medidaUnidadeDose = items[1].substring(0, 5);

        return medidaUnidadeDose;
      } catch (error) {
        this.$toast.info(
          "A Calculadora não cobre a unidade de medida desse Defensivo. Qualquer dúvida, favor entrar em contato com o Suporte."
        );

        return null;
      }
    },
    verifyExecCalcQntProd() {
      const casosPossiveisDeCalculo = ["L/ha", "L de água/ha", "L de calda/ha"];

      let unidadeMedida =
        this.currentProduct.infortecnicaReceita.unidadeVolumeCalda;

      if (!casosPossiveisDeCalculo.includes(unidadeMedida)) {
        this.$toast.info(
          "Unidade não suportada pela calculadora. Proceda ao cálculo manual!"
        );

        return false;
      }

      return true;
    },
    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },
    handleCalculateTotal() {
      const amount = Number(this.currentProduct.quantidade);
      const unitaryValue = this.currentProduct.valorUnitario;
      const totalValue = amount * unitaryValue;

      if (!this.$refs.valorTotal) return;

      this.currentProduct.valorTotal = totalValue;
      let discountValue = 0;

      if (this.sale.tipoDesconto === "Porcentagem") {
        const result = (
          this.currentProduct.valorTotal *
          (this.currentProduct.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result);
      } else {
        discountValue = this.currentProduct.desconto;
      }

      this.$refs.valorTotal.valueInput = totalValue - discountValue;
    },
    handleOpenModalRef(refFiscal = this.currentProduct.classe_imposto) {
      this.openModals("modalTaxInformation");
      this.refFromSearch = refFiscal;
    },
    assignCurrentItemTaxFromRef(ref = this.currentProduct.classe_imposto) {
      applyItemTaxFromRef(this.currentProduct, ref, this.allRefsFiscais);
    },
    handleCloseModalRef() {
      this.refFromSearch = "";
    },
    handleAssingVlUnit() {
      if (Object.keys(this.infoProd).length && !this.currentProduct.id) {
        const result = this.infoProd.find(
          (prod) => prod.lote === this.currentProduct.infortecnicaReceita.lote
        );

        this.currentProduct.valorUnitario = result?.valorVenda || 0;
        this.$refs.valorUnitario.valueInput = result?.valorVenda || 0;

        this.currentProduct.ncm = result.ncm;
        this.$refs.ncm.valueItems = result.ncm;

        this.currentProduct.classe_imposto = result.refFiscal;
        this.assignCurrentItemTaxFromRef(result.refFiscal);
        this.$refs.classe_imposto.valueItems = result.refFiscal;
      }
    },
  },

  mounted() {
    this.lockBodyScroll();

    this.loadInitialData();
    this.getAllPayment();
    this.ncmCombobox();

    if (this.verifyIfContainsPrescription) {
      this.getAllResponsibles();
    }

    if (["Pedido", "Receita Pedido"].includes(this.sale.tipo)) {
      this.findAllRefs();
    }

    this.getAllMessages();

    if (
      this.$route?.query?.origem === "inspecao" ||
      this.dataSearchFromSale.idCliente
    ) {
      this.handleSaleValues();
    }

    this.applyDefaultSaleObservations();

    this.selectedTabLabel = this.verifyIfContainsPrescription
      ? "prescription"
      : "order";
  },

  watch: {
    "dataConfig.venda.dados_adicionais_padrao"() {
      this.applyDefaultSaleObservations();
    },
    prescriptionId(newId) {
      if (newId) {
        this.loadPrescriptionForEdit(newId);
      } else {
        this.clearRecipeForm(false);
      }
    },
    dataProperties() {
      const selectedProperty = this.dataProperties.find(
        (prop) => prop.id === this.getPrescriptionId
      );

      this.ufCustomerProperty = selectedProperty?.uf || "";
    },
    discountIsChecked() {
      if (this.$refs.typeDiscount) {
        this.$refs.typeDiscount.checked =
          this.sale.tipoDesconto === "Porcentagem" ? true : false;
      }
    },
  },
  filters: {
    money(value) {
      const val = Number(value) || 0;
      return val.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.unlockBodyScroll();
    next();
  },
  beforeDestroy() {
    this.unlockBodyScroll();

    this.SET_DATA_SEARCH_FROM_SALE({});
    this.SET_SALE_ID("");
    this.reusePrescription = false;

    if (this.sale.tipo === "Receita Pedido") this.TOGGLE_DISCOUNT(false);
  },
};
</script>
<style scoped>
.inspectionImportNotice {
  background: #edf7f4;
  border: 1px solid #bcd8d1;
  border-radius: 5px;
  color: #26443d;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  gap: 3px;
  margin: 8px 0;
  padding: 9px 12px;
}

.inspectionImportNotice strong {
  color: #006458;
}

.inspectionImportProducts {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.inspectionImportProduct {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 5px 4px 9px;
  border: 1px solid #c5ddd6;
  border-radius: 999px;
  background: #fff;
}

.inspectionImportProduct button {
  padding: 2px 7px;
  border: 0;
  border-radius: 999px;
  color: #9a3029;
  background: #fff0ee;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.inspectionImportProduct label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 10px;
}

.inspectionImportProduct input {
  width: 70px;
  min-height: 25px;
  padding: 2px 5px;
  border: 1px solid #c5ddd6;
  border-radius: 3px;
}

.stock-field {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.current-stock {
  color: #00796b;
  font-family: Poppins-Medium, sans-serif;
  font-size: 10px;
  margin: 2px 0 0 4px;
}

.current-stock-negative {
  color: #d32f2f;
}

.containerPresciption {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  gap: 5px;
  height: auto;
  font-size: 12px;
  overflow-x: hidden;
}
.MobileStepperContainer {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  overflow: hidden;
}
/* steps  */
.stepper-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 4px;
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  z-index: 10;
  position: relative;
}

.step-nav-btn {
  width: 30px;
  height: 30px;
  min-width: 30px;
  border: 1px solid #d7e1dc;
  border-radius: 999px;
  background: #006256;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.step-nav-btn:disabled {
  color: #9ca3af;
  border-color: #e5e7eb;
  cursor: not-allowed;
  opacity: 0.7;
}

.stepper-center {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stepper-pills {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.step-pill {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1px solid #dbe5e1;
  background: #f8fbfa;
  border-radius: 999px;
  padding: 6px 4px;
  color: #6b7280;
  min-width: 0;
}

.step-pill.completed {
  border-color: #91c4ba;
  background: #e9f6f2;
  color: #006256;
}

.step-pill.active {
  background: #006256;
  border-color: #006256;
  color: #ffffff;
  box-shadow: 0 0 0 2px rgba(0, 98, 86, 0.12);
}

.step-pill-index {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  flex-shrink: 0;
}

.step-pill:not(.active) .step-pill-index {
  background: #e5e7eb;
}

.step-pill-label {
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stepper-progress-track {
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 999px;
  overflow: hidden;
}

.stepper-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #0da77f 0%, #006256 100%);
  transition: width 0.25s ease;
}

.stepper-content-wrapper {
  flex: 1;
  position: relative;
  overflow-x: hidden;
  padding: 0px;
  width: 100%;
}

.step-panel {
  width: 100%;
  position: absolute;
  top: 15px;
  left: 0;
  padding: 0 1px;
  padding-bottom: 80px;
}

.section-mobile {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 15px;
}

.formFront {
  display: flex;
  flex-direction: column;
}

.mobile-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-row-split {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.mobile-footer-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 20;
}

.nav-btn {
  min-width: 90px;
  font-size: 13px;
}

.indicator-dots {
  display: flex;
  gap: 5px;
}

.indicator-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #e0e0e0;
}

.indicator-dots span.active {
  background-color: #006256;
  width: 8px;
  height: 8px;
}

.slide-next-enter-active,
.slide-next-leave-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: all 0.3s ease;
}

.slide-next-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-next-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-prev-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-prev-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
/* steps  */

.selectPlus {
  position: relative;
  width: 33%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.carroselCtn {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.collapsible-section {
  display: flex;
  gap: 10px;
  flex-direction: column;
  max-height: 2000px;
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
}

.collapsible-section.collapsed {
  max-height: 0;
  margin-top: -15px;
}

.contentDataTotals {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.contentFreteTotals input {
  background-color: white !important;
  border: solid 1px #d9d9d9;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  bottom: 22px;
  left: 5px;
  z-index: 2;
  background-color: #ffff;
  font-size: 12px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  padding: 0 0.2em;
}

.dashed {
  border-bottom: 1px dashed #b1aaa5;
  width: 100%;
  margin: 10px 0;
}

.inputTotals {
  display: flex;
  align-items: center;
  gap: 30px;
  color: #666360;
}

.inputTotals input {
  border: none;
  outline: none;
  text-align: end;
  padding-right: 5px;
  background-color: #d9d9d9;
  border-radius: 5px;
  height: 30px;

  border: solid 1px #d9d9d9;
}

.contentTotals {
  width: 370px;
  display: flex;
  flex-direction: column;
  text-align: right;
  align-items: flex-end;
  font-size: 14px;
  gap: 5px;
}
.btnsSale {
  border-radius: 5px;
  background-color: #006256;
  width: 135px;
  height: 28px;
  border: none;
  color: white;
  font-size: 12px;
}

.btnGenerateBills {
  background-color: transparent;
  border: solid 1px black;
  color: black;
}

.observacoes {
  font-size: 12px;
  color: #b2b2b2;
  font-style: italic;
}

.StatementOnAccount {
  display: flex;
  align-items: center;
  height: 30px;
  width: 100%;
  gap: 1px;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 40px;
  background: #eeeeee;
  color: #000000;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  height: 30px;
  background-color: #006458;
  color: white;
  border-bottom: 2px solid white;
  border-radius: 10px 10px 0 0;
  transform: translateY(-4px);
}

.StatementOnAccountItem:hover {
  background-color: #006458;
  color: white;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.sectionAgro {
  border: 1px solid #c8dfd5;
  border-radius: 5px;
  padding: 10px !important;
}
/* radio */
.radio-input input {
  display: none;
}

.radio-input {
  --container_width: 250px;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 10px;
  width: var(--container_width);
  background-color: #fff;
  color: #7a9c87;
  overflow: hidden;
  border: 1px solid #7a9c87;
}

.radio-input label {
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  letter-spacing: 1px;
  font-size: 11px;
  height: 30px;
  margin: 0 !important;
}

.selection {
  display: none;
  position: absolute;
  height: 100%;
  width: calc(var(--container_width) / 3);
  z-index: 0;
  left: 0;
  top: 0;
  transition: 0.15s ease;
}

.radio-input label:has(input:checked) {
  color: #fff;
}

.radio-input label:has(input:checked) ~ .selection {
  background-color: #7a9c87;
  display: inline-block;
}

.radio-input label:nth-child(1):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 0 / 3));
}

.radio-input label:nth-child(2):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 1 / 3));
}

.radio-input label:nth-child(3):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 2 / 3));
}
/* radio */
.inputItemVlUnit {
  width: 13%;
}

.inputItemVlTot {
  width: 13%;
}

.inputItemDesc {
  width: 10%;
}

.itemToggleDesc {
  width: 52px;
  position: relative;
}

.screenProducts {
  align-items: center;
  background: white;
  cursor: pointer;
  display: flex;
  width: 2em;
  height: 2em;
  justify-content: center;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContent {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.rowContentBtn {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: flex-end;
  gap: 10px;
}

.rowContentMensagem {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
}

.wrapper-progressBar {
  width: 100%;
}

.containerTotalsItems {
  display: flex;
  gap: 1rem;
  padding: 0.8rem;
  background-color: rgb(248 248 248);
  margin-top: 1rem;
  border-radius: 8px;
}

.rowTotalsItems {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex: 1 1 auto;
  max-width: 200px;
  background-color: white;
  padding: 0.3rem 0.5rem;
  border-radius: 8px;
  box-shadow: 0px 0 0px 1px rgba(0, 0, 0, 0.207);
}

.boxTotalsItems {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.valueTotalsItems {
  margin: 0;
  font-weight: 600;
  color: black;
  font-size: 13px;
}

.containerProgress {
  margin-top: 30px;
  width: 10%;
  right: 0px;
  top: 200px;
  position: fixed;
  z-index: 2;
  border-radius: 10px;
  padding: 10px;
}

.progressBar {
  display: flex;
  flex-direction: column;
}

/* label */
.inputProgress {
  appearance: none;
  display: block;
  margin: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: hsla(0, 0%, 0%, 0.815) 0 1px 1px,
    inset hsla(0, 0%, 0%, 0.5) 0 0 0 1px;
  background-image: -webkit-radial-gradient(
    hsla(200, 100%, 90%, 1) 0%,
    #006256 15%,
    hsla(200, 100%, 60%, 0.3) 28%,
    hsla(200, 100%, 30%, 0) 70%
  );
  transition: background-position 0.15s cubic-bezier(0.8, 0, 1, 1),
    -webkit-transform 0.25s cubic-bezier(0.8, 0, 1, 1);
  background-repeat: no-repeat;
}

/* #006256; */
.inputProgress:checked {
  background-color: #0bc06f;
  transition: background-position 0.2s 0.15s cubic-bezier(0, 0, 0.2, 1),
    -webkit-transform 0.25s cubic-bezier(0, 0, 0.2, 1);
}

.inputProgress:active {
  transform: scale(1);
  transition: -webkit-transform 0.1s cubic-bezier(0, 0, 0.2, 1);
}

.inputProgress,
.inputProgress:active {
  background-position: 0 24px;
}

.inputProgress:checked {
  background-position: 0 0;
}

/* .inputProgress:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 6px;
  background-color: #00625698;
  top: -17px;
  left: 3px;
  z-index: -1;
  transform: rotate(270deg);
} */

.inputProgress:checked ~ .inputProgress,
.inputProgress:checked ~ .inputProgress:active {
  background-position: 0 -24px;
}
/* label */

.alertModal {
  font-size: 11px;
  color: rgb(115, 0, 0);
  padding-left: 40px;
  margin: -15px;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #006256;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 75px;
  padding-left: 5px;
  border: solid 1px #b2b2b2;
  resize: none;
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.btnRef {
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.rowObservation {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  height: auto;
  position: relative;
}

.input-group-ob {
  width: 100%;
}

.input-group {
  width: 33%;
}

.user-label-ob {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.user-label-top {
  position: absolute;
  left: 10px;
  font-size: 11px;
  top: 1px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

tr:nth-child(even) {
  background: #f1f1f1;
}

td {
  text-transform: capitalize;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  height: 30vh;
  max-height: 30vh;
  overflow: auto;
  width: 100%;
  max-width: 100%;
  border: 1px dashed #b2b2b2;
  border-radius: 5px;
  position: relative;
}

.titleTable {
  font-size: 15px;
  padding: 5px;
  text-align: center;
  text-decoration: underline;
}
.rowSupplier {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 65px;
  gap: 20px;
  padding: 2px 20px;
  cursor: context-menu;
  color: #006257;
  font-size: 8px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.207);
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.celTableActions {
  display: flex;
  gap: 10px;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #709e8a;
  border-radius: 5px;
  height: 23px;
  width: 23px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}

.btnActions {
  width: 47px;
  max-width: 47px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  color: white;
  border-radius: 0 3px 3px 0;
}

.btnActions1 {
  border-radius: 0;
}

.contentActions {
  color: white;
}

.moreDetailsPesticides {
  padding: 10px;
  font-size: 12px;
}
/* ----------------------------  */
/* The slider */
.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.tooltipDiscount {
  z-index: 3;
  width: 150px;
  padding: 5px;
  font-size: 12px;
  position: absolute;
  color: black;
  border-radius: 5px;
  top: -25px;
  right: -10px;
}

.tooltipItems {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

.formFront {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  position: relative;
}

.descriptionSection {
  gap: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #333;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
}

.descriptionSection span {
  font-size: 0.8rem;
}

.btnResetCultureDiag {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 11px;
  color: #006256 !important;
  background-color: transparent !important;
  padding: 0.2em 0;
  border: none !important;
  line-height: 1;
  outline: none !important;
  box-shadow: none !important;
}

.btnResetCultureDiag p {
  margin: 0;
}

.btnResetCultureDiag:hover {
  border-bottom: solid 1px #006256 !important;
  border-radius: 0 !important;
}

.content-btn-fixed {
  width: 100%;
  padding: 0.7% 0px;
  left: 0px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffff;
  z-index: 10;
  box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.197);
}

.form-btn {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #006256;
  color: whitesmoke;
  border-radius: 3px;
  width: 20%;
  height: 28px;
}

.form-btn-calculator {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  background: #7a9c87;
  color: whitesmoke;
  border-radius: 3px;
  height: 28px;
  border: none;
}

.form-btn-calculator:hover {
  background: #006256;
}

.form-btn-calculator:focus {
  background: #006256;
  box-shadow: none !important;
}

.form-btn-inventory {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #006256;
  border: 1px solid black;
  color: whitesmoke;
  border-radius: 3px;
  width: 10%;
  height: 28px;
}

.headerInventory {
  display: flex;
  justify-content: center;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.selectPlus1 {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 22px;
  left: 5px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect3 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  top: -10px;
  left: 5px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

/* ALERT MODAL */

.containerAlertModal {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 0.5rem;
}

.btnCloseAlertModal {
  width: 22px;
  height: 22px;
  position: absolute;
  right: -5px;
  top: -5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff000021;
  border-radius: 5px;
  box-shadow: 0 0 0 1px #a52a2a6b;
  transition: ease-in all 0.1s;
  cursor: pointer;
}

.btnCloseAlertModal:hover {
  background-color: #ff00005d;
  transition: ease-in all 0.1s;
}

.contentAlertIcon {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: oklch(96.2% 0.059 95.617);
  border-radius: 50%;
  box-shadow: oklch(0.67 0.18 58.32 / 0.55) 0px 0px 0px 1px;
}

.contentAlertItems {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;
}

.pesticideAlertArea,
.cultureAlertArea,
.diagnosticAlertArea {
  display: flex;
  gap: 0.8rem;
  padding: 0.8rem;
  border-radius: 8px;
}

.pesticideAlertArea {
  box-shadow: 0 0 0 1px oklch(0.82 0.06 254.29);
  background-color: oklch(97% 0.014 254.604);
}

.cultureAlertArea {
  box-shadow: 0 0 0 1px oklch(0.87 0.15 153.71);
  background-color: oklch(98.2% 0.018 155.826);
}

.diagnosticAlertArea {
  box-shadow: 0 0 0 1px oklch(0.85 0.13 72.7);
  background-color: oklch(98% 0.016 73.684);
}

.contentBtnsAlertModal {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.contentBtnsAlertModal button {
  width: 100%;
  outline: none !important;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.357);
  border: none !important;
  border-radius: 5px;
  padding: 0.3rem 1rem !important;
  font-size: 0.83rem;
  background-color: white;
  transition: ease-in all 0.1s;
}

.contentBtnsAlertModal button:hover {
  background-color: whitesmoke;
  transition: ease-in all 0.1s;
}

.continueAlertBtn {
  background-color: rgb(4, 138, 123) !important;
  color: white !important;
  transition: ease-in all 0.1s;
}

.continueAlertBtn:hover {
  background-color: rgb(0, 98, 87) !important;
  transition: ease-in all 0.1s;
}

/* ============================================
   MOBILE OPTIMIZATIONS
   ============================================ */

.item-tax-ref-field-mobile {
  position: relative;
  width: 100%;
}

.item-tax-ref-field-ref {
  box-sizing: border-box;
  /* padding-right: 24px; */
}

@media (max-width: 900px) {
  .containerPresciption .rowContent,
  .containerPresciption .rowContentMensagem,
  .containerPresciption .selectPlus,
  .containerPresciption .selectPlus1,
  .containerPresciption .mobile-row-split,
  .containerPresciption .mobile-column {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .containerPresciption .rowContent > div[style*="display: flex"],
  .containerPresciption
    .rowContent
    > div[style*="justify-content: space-between"] {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .containerPresciption .rowContent input,
  .containerPresciption .rowContent select,
  .containerPresciption .rowContent textarea,
  .containerPresciption .rowContent .borderInput,
  .containerPresciption .rowContent .inputTextArea,
  .containerPresciption .rowContent .selectPlus,
  .containerPresciption .rowContent .selectPlus1,
  .containerPresciption .rowContent > div,
  .containerPresciption .rowContent > div > * {
    width: 100% !important;
    min-width: 0;
    box-sizing: border-box;
  }

  .containerPresciption .rowContent *[style*="width:"] {
    width: 100% !important;
  }
  input[type="text"],
  input[type="number"],
  input[type="date"],
  input[type="email"],
  input[type="tel"],
  select,
  textarea {
    font-size: 16px !important;
  }

  .borderInput {
    font-size: 16px !important;
  }

  .inputTextArea {
    font-size: 16px !important;
  }

  .containerPresciption {
    margin-top: 1rem;
    padding: 0 8px;
  }

  .headerInventory {
    padding: 12px 0;
  }

  .headerInventory p {
    font-size: 1.1rem !important;
  }

  .stepper-header {
    padding: 8px 4px;
    gap: 4px;
  }

  .step-circle {
    width: 28px;
    height: 28px;
    font-size: 11px;
  }

  .step-label {
    font-size: 9px;
    margin-top: 4px;
  }

  .step-item:not(:last-child)::after {
    top: 14px;
  }

  .step-panel {
    padding: 0 8px;
    padding-bottom: 40px;
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .formFront {
    gap: 12px;
    width: 100%;
  }

  .rowContent {
    gap: 12px;
    padding: 12px 0;
    width: 100%;
    box-sizing: border-box;
  }

  .rowContentMensagem {
    gap: 12px;
  }

  .section-mobile,
  .sectionAgro {
    background: white;
    border-radius: 10px;
    padding: 12px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 12px;
  }

  .rowContainer {
    padding: 12px !important;
    margin-bottom: 12px;
  }

  .descriptionSection {
    font-size: 14px;
    font-weight: 700;
    border-bottom: 2px solid #e8f5e8;
    color: #2d5016;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .rowContent .selectPlus {
    width: 100%;
  }

  .borderInput {
    padding: 4px 12px !important;
    border-radius: 8px;
  }

  .borderInput:focus {
    border-color: #4caf50;
  }

  .inputTextArea {
    min-height: 200px;
    padding: 12px;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
  }

  .inputTextArea:focus {
    border-color: #4caf50;
  }

  .rowContentMensagem .selectPlus1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .fixedSelect2 {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    bottom: auto !important;
    margin-bottom: 4px;
    background-color: transparent !important;
    font-size: 12px !important;
    display: block;
  }

  .fixedSelect3 {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    bottom: auto !important;
    margin-bottom: 4px;
    background-color: transparent !important;
    font-size: 12px !important;
    display: block;
  }

  .StatementOnAccount {
    gap: 4px;
    overflow-x: auto;
    padding: 4px 0;
  }

  .StatementOnAccountItem {
    padding: 0 20px;
    font-size: 12px;
    min-width: 120px;
    white-space: nowrap;
  }

  .btnsSale {
    height: 44px;
    font-size: 14px !important;
    font-weight: 600;
    border-radius: 8px;
  }

  .form-btn {
    height: 44px;
    font-size: 14px !important;
    font-weight: 600;
    border-radius: 8px;
  }

  .mobile-footer-nav {
    height: 70px;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  }

  .nav-btn {
    min-width: 110px;
    height: 46px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
  }

  .contentTotals {
    width: 100%;
    gap: 10px;
  }

  .inputTotals {
    gap: 10px;
    font-size: 14px;
  }

  .inputTotals input {
    font-size: 16px;
    padding: 10px;
  }

  .containerTotalsItems {
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px;
  }

  .rowTotalsItems {
    flex: 1 1 calc(50% - 6px);
    min-width: 140px;
    padding: 10px;
  }

  .valueTotalsItems {
    font-size: 14px;
  }

  .radio-input {
    --container_width: 100%;
    height: 40px;
    position: relative;
    display: flex;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #7a9c87;
  }

  .radio-input label {
    flex: 1;
    font-size: 12px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 2;
    position: relative;
    transition: color 0.2s ease;
    margin: 0 !important;
  }

  .radio-input .selection {
    display: none !important;
  }

  .radio-input label:has(input:checked) {
    background-color: #7a9c87;
    color: #fff;
  }

  .radio-input label:nth-child(1):has(input:checked) ~ .selection,
  .radio-input label:nth-child(2):has(input:checked) ~ .selection,
  .radio-input label:nth-child(3):has(input:checked) ~ .selection {
    transform: none;
  }

  .iconSelect {
    width: 36px;
    height: 36px;
    border-radius: 6px;
  }

  .selectPlus {
    gap: 8px;
  }

  .fixedSelect {
    font-size: 12px !important;
  }

  .containerProgress {
    display: none;
  }

  .containerAlertModal {
    padding: 16px;
    gap: 16px;
  }

  .contentAlertItems {
    gap: 12px;
  }

  .pesticideAlertArea,
  .cultureAlertArea,
  .diagnosticAlertArea {
    padding: 12px;
    border-radius: 8px;
  }

  .contentBtnsAlertModal {
    flex-direction: column;
  }

  .contentBtnsAlertModal button {
    height: 44px;
    font-size: 14px !important;
  }

  .carroselCtn {
    margin-top: 12px;
    overflow-x: auto;
  }

  .collapsible-section {
    gap: 12px;
  }

  .rowObservation {
    padding: 12px 0;
  }

  .delBill {
    padding: 12px 0;
  }

  .btnRef {
    width: 36px;
    height: 36px;
  }

  .content-btn-fixed {
    background-color: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 8px 12px;
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
    gap: 8px;
    align-items: center;
    flex-wrap: nowrap;
  }

  .content-btn-fixed > div:first-child {
    width: auto !important;
    flex: 0 0 auto;
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .content-btn-fixed > div:nth-child(2) {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .content-btn-fixed .form-btn {
    min-height: 44px;
    font-size: 16px !important;
    padding: 0 12px;
    width: auto !important;
    flex: 1 1 auto;
  }

  .content-btn-fixed > div:first-child .form-btn {
    flex: 0 0 auto;
  }

  .content-btn-fixed .btnActions {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    border-radius: 8px;
  }

  .ContentTable {
    overflow-x: hidden;
  }

  .rowSupplier {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    padding: 12px;
    height: auto;
    align-items: start;
    box-sizing: border-box;
  }

  .rowSupplier .celTable {
    width: 100% !important;
  }

  .rowSupplier .celTable:nth-child(2) {
    grid-column: 1 / -1;
    font-size: 13px;
    font-weight: 600;
  }

  .rowSupplier .celTable span {
    word-break: break-word;
  }

  .rowSupplier .celTableActions {
    grid-column: 1 / -1;
    width: 100%;
    display: flex;
    gap: 8px;
    justify-content: stretch;
  }

  .rowSupplier .celInfos {
    flex: 1;
    min-height: 40px;
    width: auto;
  }

  #dadosGerais {
    margin-bottom: 40px;
    background: white;
    border-radius: 10px;
    padding: 12px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #c8dfd5;
  }

  #dadosProdutos {
    margin-bottom: 40px;
  }
}

@media (max-width: 375px) {
  .step-label {
    font-size: 8px;
  }

  .step-circle {
    width: 26px;
    height: 26px;
    font-size: 10px;
  }

  .StatementOnAccountItem {
    padding: 0 16px;
    font-size: 11px;
    min-width: 100px;
  }

  .descriptionSection {
    font-size: 13px;
  }
}

.modal-mobile-unavailable-content {
  position: relative;
  padding: 1.5rem;
  text-align: center;
}

.modal-mobile-unavailable-content .btnCloseAlertModal {
  right: 10px;
  top: 10px;
}

.modal-mobile-unavailable-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.modal-mobile-unavailable-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
}

.modal-mobile-unavailable-body {
  margin-bottom: 1.5rem;
  color: #4b5563;
  line-height: 1.5;
}

.modal-mobile-unavailable-body p {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.modal-mobile-unavailable-footer {
  display: flex;
  justify-content: center;
}

.btn-understood {
  background-color: #10b981;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-understood:hover {
  background-color: #059669;
}

.btn-understood:active {
  transform: scale(0.98);
}
</style>
